import i18n from "i18next";
import { initReactI18next } from "react-i18next";

const resources = {
  id: {
    translation: {
      // ── Common ────────────────────────────────────────────────────────────
      "common.save": "Simpan",
      "common.cancel": "Batal",
      "common.loading": "Memuat...",
      "common.error": "Terjadi kesalahan",
      "common.back": "Kembali",
      "common.or": "atau",
      "common.required": "Wajib diisi",
      "common.submit": "Kirim",
      "common.delete": "Hapus",
      "common.edit": "Edit",
      "common.close": "Tutup",
      "common.retry": "Coba Lagi",
      "common.copied": "Disalin!",

      // ── Nav ────────────────────────────────────────────────────────────────
      "nav.analyze": "Analisis",
      "nav.discover": "Temukan",
      "nav.videos": "Videos",
      "nav.history": "Riwayat",
      "nav.account": "Akun",
      "nav.analytics": "Analytics",
      "nav.dashboard": "Dashboard",
      "nav.admin": "Admin",
      "nav.pricing": "Harga",
      "nav.signIn": "Masuk",
      "nav.getStarted": "Mulai Gratis",
      "nav.newAnalysis": "Analisis Baru",
      "nav.subscription": "Langganan",
      "nav.paymentHistory": "Riwayat Pembayaran",
      "nav.editProfile": "Edit Profil",
      "nav.signOut": "Keluar",

      // ── Home ───────────────────────────────────────────────────────────────
      "home.badge": "Platform Forensik Media Digital Berbasis AI",
      "home.hero1": "Deteksi Deepfake",
      "home.hero2": "dalam Hitungan Detik.",
      "home.analysisEngine": "Mesin Analisis Risiko",
      "home.heroTitle": "Analisis Risiko Media",
      "home.heroDesc":
        "Veriksa menganalisis video, audio, dan gambar untuk mendeteksi deepfake, manipulasi AI, dan konten sintetis. Dapatkan laporan analisis risiko forensik dalam hitungan detik langsung di browser Anda.",
      "home.cta.analyze": "Mulai Analisis Gratis",
      "home.cta.demo": "Lihat Cara Kerja",
      "home.trusted": "Dipercaya oleh jurnalis & peneliti media Indonesia",
      "home.stats.accuracy": "Akurasi Deteksi",
      "home.stats.time": "Waktu Rata-rata",
      "home.stats.highRisk": "Risiko Tinggi Terdeteksi",
      "home.stats.lowRisk": "Risiko Rendah",
      "home.stats.analyzed": "Analisis Selesai",
      "home.howItWorks": "Cara Kerja Veriksa",
      "home.howItWorksNav": "Cara Kerja",
      "home.step1.title": "Upload atau Paste URL",
      "home.step1.desc":
        "Upload file video langsung atau tempel URL dari YouTube, Twitter/X, TikTok, dan platform lainnya.",
      "home.step2.title": "Analisis AI Forensik",
      "home.step2.desc":
        "Model AI kami menganalisis artefak deepfake, konsistensi temporal, dan pola manipulasi secara mendalam.",
      "home.step3.title": "Laporan Lengkap Instan",
      "home.step3.desc":
        "Dapatkan laporan forensik detail dengan skor kepercayaan, artefak yang terdeteksi, dan rekomendasi tindak lanjut.",
      "home.features.title": "Kualitas Enterprise. Harga yang Masuk Akal.",
      "home.features.eyebrow": "Kapabilitas",
      "home.features.advanced.title": "Deteksi Sinyal Risiko AI",
      "home.features.advanced.desc":
        "Deteksi manipulasi AI dari artefak visual, inkonsistensi temporal, dan pola statistik — dalam satu laporan terpadu.",
      "home.features.url.title": "Analisis Langsung dari URL",
      "home.features.url.desc":
        "Tempel URL dari YouTube, Twitter/X, TikTok, atau platform lainnya — tanpa perlu mengunduh manual.",
      "home.features.fast.title": "Hasil dalam Hitungan Detik",
      "home.features.fast.desc":
        "Laporan penilaian risiko lengkap dalam 30–120 detik, tergantung durasi dan kompleksitas media.",
      "home.features.secure.title": "Privasi Terjamin",
      "home.features.secure.desc":
        "Media Anda diproses dengan aman dan dihapus otomatis setelah analisis. Data Anda tidak pernah disimpan permanen.",
      "home.useCases.eyebrow": "Untuk Siapa Veriksa",
      "home.useCases.title": "Dibangun untuk Tim yang Butuh Verifikasi Cepat",
      "home.useCases.desc":
        "Veriksa dipakai lintas fungsi: newsroom, tim komunikasi, riset, hingga tim kepatuhan.",
      "home.useCases.journalist.title": "Jurnalis & Redaksi",
      "home.useCases.journalist.desc":
        "Cek keaslian media sebelum publikasi untuk menurunkan risiko misinformasi.",
      "home.useCases.comms.title": "Tim Komunikasi",
      "home.useCases.comms.desc":
        "Verifikasi konten viral dengan cepat sebelum menyusun pernyataan resmi.",
      "home.useCases.research.title": "Peneliti & Akademisi",
      "home.useCases.research.desc":
        "Dapatkan sinyal risiko terstruktur untuk observasi dan studi konten digital.",
      "home.useCases.enterprise.title": "Kepatuhan & Brand",
      "home.useCases.enterprise.desc":
        "Pantau potensi impersonasi dan konten manipulatif yang menyasar reputasi merek.",
      "home.pricing.title": "Harga Transparan, Tanpa Kejutan",
      "home.pricing.desc": "Mulai gratis. Upgrade kapan pun Anda siap.",
      "home.cta.title": "Jangan Percaya Begitu Saja. Verifikasi.",
      "home.cta.desc":
        "Mulai gratis — tanpa kartu kredit, tanpa komitmen. Analisis pertama Anda hanya butuh beberapa detik.",
      "home.cta.start": "Mulai Sekarang — Gratis",
      "home.footer.tagline": "Penilaian Risiko Media Otomatis",
      "home.footer.rights": "Semua hak dilindungi.",

      // ── Login ──────────────────────────────────────────────────────────────
      "login.leftBadge": "Analisis Risiko Media",
      "login.leftTitle": "Verifikasi Media.\nLindungi Kepercayaan.",
      "login.leftDesc":
        "Platform AI terpercaya untuk mendeteksi deepfake, manipulasi konten, dan konten sintetis — dirancang untuk profesional media Indonesia.",
      "login.leftF1": "Deteksi deepfake dengan teknologi AI berlapis ganda",
      "login.leftF2": "Analisis frame-per-frame bertenaga AI",
      "login.leftF3": "Laporan forensik lengkap dengan confidence score",
      "login.title": "Masuk ke Akun",
      "login.subtitle": "Belum punya akun?",
      "login.signupLink": "Daftar gratis",
      "login.email": "Email",
      "login.password": "Password",
      "login.forgot": "Lupa password?",
      "login.forgotPassword": "Lupa password?",
      "login.submit": "Masuk",
      "login.google": "Lanjutkan dengan Google",
      "login.divider": "atau masuk dengan email",
      "login.success": "Berhasil masuk! Selamat datang kembali.",
      "login.error.invalid": "Email atau password salah. Silakan coba lagi.",
      "login.failed": "Gagal masuk. Periksa kembali email dan password Anda.",
      "login.otpSent": "Kode verifikasi telah dikirim ke email Anda",
      "login.otpTitle": "Verifikasi OTP",
      "login.otpDesc": "Kode dikirim ke",
      "login.otpDigits": "Masukkan 6 digit kode OTP",
      "login.otpInvalid": "OTP tidak valid",
      "login.otpSubmit": "Verifikasi & Masuk",
      "login.otpVerifying": "Memverifikasi...",
      "login.otpResendBtn": "Kirim ulang OTP",
      "login.otpResending": "Mengirim...",
      "login.otpResent": "OTP baru dikirim!",
      "login.otpResendFail": "Gagal mengirim ulang OTP",
      "login.backToLogin": "Kembali ke login",
      "login.welcomeBack": "Selamat datang, {{name}}!",
      "login.heroTag": "Analisis Risiko Media",
      "login.heroTitle": "Verifikasi Media\nDigital dengan AI",
      "login.heroDesc":
        "Platform AI terpercaya untuk mendeteksi deepfake dan konten manipulasi — akurat, cepat, dan mudah digunakan.",
      "login.feature1": "Deteksi deepfake bertenaga model AI terdepan",
      "login.feature2": "Laporan analisis akurat dengan confidence score",
      "login.feature3": "Dukungan upload file & URL media sosial",

      // ── Register ───────────────────────────────────────────────────────────
      "register.title": "Buat Akun Gratis",
      "register.subtitle": "Sudah punya akun?",
      "register.signinLink": "Masuk",
      "register.name": "Nama Lengkap",
      "register.email": "Email",
      "register.password": "Password",
      "register.passwordHint": "Minimal 8 karakter",
      "register.password_confirm": "Konfirmasi Password",
      "register.password_mismatch": "Password tidak cocok",
      "register.submit": "Buat Akun",
      "register.google": "Daftar dengan Google",
      "register.divider": "atau daftar dengan email",
      "register.success": "Akun berhasil dibuat! Selamat datang di Veriksa 🎉",
      "register.terms_prefix": "Saya telah membaca dan setuju dengan",
      "register.terms": "Terms of Service",
      "register.and": "dan",
      "register.privacy": "Privacy Policy",
      "register.terms_error":
        "Anda harus menyetujui Terms of Service dan Privacy Policy untuk melanjutkan",
      "register.newsletter":
        "Saya ingin menerima newsletter dan info terbaru dari Veriksa",
      "register.product_updates":
        "Saya ingin menerima update produk dan pengumuman dari Veriksa",
      "register.terms_notice_prefix": "Dengan membuat akun, Anda setuju dengan",
      "register.and_privacy": "dan",
      "register.terms_notice_suffix":
        "Kami akan mengirimkan email terkait akun Anda sesuai preferensi yang Anda pilih.",
      "register.verify.emailSent": "Email verifikasi telah dikirim",
      "register.error.tooMany":
        "Terlalu banyak permintaan. Coba lagi dalam 15 menit.",
      "register.error.registerFailed": "Gagal mendaftar",
      "register.error.resendFailed": "Gagal mengirim ulang email",
      "register.step2.title": "Cek Email Anda",
      "register.step2.subtitle": "Kami telah mengirimkan link verifikasi ke",
      "register.step2.nextStepsTitle": "Langkah selanjutnya:",
      "register.step2.next1": "Buka email yang baru saja diterima",
      "register.step2.next2": 'Klik tombol "Verifikasi Email"',
      "register.step2.next3": "Akun Anda akan langsung aktif",
      "register.step2.notePrefix": "Link verifikasi berlaku selama",
      "register.step2.noteDuration": "15 menit",
      "register.step2.resendPrompt": "Tidak terima email?",
      "register.step2.backToForm": "Kembali ke formulir",
      "register.step2.haveAccount": "Sudah punya akun?",

      // ── Analyze ────────────────────────────────────────────────────────────
      "analyze.title": "Analisis Forensik",
      "analyze.waitNote":
        "Tetap di halaman ini — kami sedang menganalisis media Anda. Proses biasanya selesai dalam 30–120 detik.",
      "analyze.freePlanNotice":
        "Anda menggunakan paket gratis dengan kuota analisis terbatas.",
      "analyze.freePlanUpgrade":
        "Upgrade ke paket berbayar untuk kuota analisis lebih besar.",
      "analyze.subtitle":
        "Unggah media atau tempel URL — hasil analisis dalam hitungan detik.",
      "analyze.tab.upload": "Upload File",
      "analyze.tab.url": "URL Video",
      "analyze.url.label": "URL Video",
      "analyze.url.placeholder":
        "https://youtube.com/watch?v=... atau URL video langsung",
      "analyze.url.hint":
        "Mendukung YouTube, Twitter/X, TikTok, dan URL video langsung",
      "analyze.model.label": "AI Model",
      "analyze.btn.analyze": "Mulai Analisis",
      "analyze.btn.analyzing": "Menganalisis...",
      "analyze.btn.selectFile": "Pilih file untuk melanjutkan",
      "analyze.btn.enterUrl": "Masukkan URL untuk melanjutkan",
      "analyze.error.noFile": "Pilih file media terlebih dahulu",
      "analyze.error.noUrl": "Masukkan URL media terlebih dahulu",
      "analyze.error.quotaMonthly": "Kuota bulanan habis. Upgrade paket Anda.",
      "analyze.error.quotaDaily": "Batas harian tercapai. Coba lagi besok.",
      "analyze.stage0": "Menginisialisasi scanner forensik...",
      "analyze.stage1": "Memproses frame video...",
      "analyze.stage2": "Menjalankan model deteksi deepfake...",
      "analyze.stage3": "Menganalisis artefak temporal...",
      "analyze.stage4": "Memeriksa konsistensi pencahayaan & bayangan...",
      "analyze.stage5": "Menyusun laporan penilaian risiko...",
      "analyze.quota.monthly": "Sisa kuota bulan ini",
      "analyze.quota.daily": "Sisa kuota hari ini",

      // ── Results ────────────────────────────────────────────────────────────
      "results.title": "Laporan Analisis",
      "results.forensicReport": "Laporan Analisis",
      "results.verdictLabel": "Hasil Analisis",
      "results.verdict.REAL": "ASLI",
      "results.verdict.FAKE": "PALSU",
      "results.verdict.SUSPICIOUS": "MENCURIGAKAN",
      "results.verdict.UNCERTAIN": "TIDAK PASTI",
      "results.confidence": "Tingkat Kepercayaan",
      "results.detectionCertainty": "Kepastian Deteksi",
      "results.summary": "Ringkasan",
      "results.artifacts": "Artefak Terdeteksi",
      "results.technical": "Detail Teknis",
      "results.model": "Model AI",
      "results.inputType": "Tipe Input",
      "results.aiEngine": "Mesin AI",
      "results.date": "Tanggal Analisis",
      "results.videoName": "Nama Media",
      "results.contentInfo": "Konten Media",
      "results.newAnalysis": "Analisis Baru",
      "results.share": "Bagikan",
      "results.copyLink": "Salin Link",
      "results.linkCopied": "Link tersalin!",
      "results.makePublic": "Jadikan Publik",
      "results.makePrivate": "Jadikan Privat",
      "results.public": "Publik",
      "results.private": "Privat",
      "results.publicBadge": "Hasil ini dapat dilihat publik",
      "results.privateBadge": "Hanya Anda yang dapat melihat hasil ini",
      "results.downloadPdf": "Unduh PDF",
      "results.facial": "Analisis Wajah",
      "results.temporal": "Konsistensi Temporal",
      "results.lighting": "Pencahayaan & Bayangan",
      "results.audio": "Analisis Audio",
      "results.audioVisualSync": "Sinkronisasi Audio-Visual",
      "results.metadata": "Analisis Metadata",
      "results.background": "Analisis Latar Belakang",
      "results.overallQuality": "Kualitas Keseluruhan",
      "results.rawResponse": "Respons Mentah AI",
      "results.publicShared":
        "Laporan ini tersedia untuk umum dan dapat diakses siapa saja",
      "results.signupCta": "Daftar gratis — analisis media Anda sekarang",
      "results.notFound": "Laporan tidak dapat diakses",
      "results.notFoundTitle": "Laporan Tidak Tersedia",
      "results.notFoundDesc":
        "Laporan ini bersifat privat, telah dihapus, atau tidak ditemukan di sistem.",
      "results.meta": "Meta",
      "results.upload": "Upload File",
      "results.langMismatch": "Analisis ini dilakukan dalam bahasa lain",
      "results.hiveTitle": "DETEKSI HIVE AI",
      "results.hiveAiGenerated": "AI-Generated",
      "results.hiveDeepfake": "Deepfake",
      "results.hiveAiAudio": "Audio AI",
      "results.hiveFrames": "Frame",
      "results.hiveGenerator": "Sumber Terdeteksi",
      "results.detectionTitle": "DETEKSI AI",
      "results.scoreReal": "Asli",
      "results.scoreAiGenerated": "AI-Generated",
      "results.scoreDeepfake": "Deepfake",
      "results.scoreAiAudio": "Audio AI",
      "results.generationSources": "Sumber Pembuatan",
      "results.noGenerationSources": "Tidak ada AI generator yang terdeteksi",
      "results.generationSourcesTooltip":
        "Sumber ini menunjukkan model AI yang kemungkinan digunakan untuk membuat konten ini.",
      "results.seeMore": "Lihat semua sumber",
      "results.seeLess": "Lihat lebih sedikit",
      "results.pdfGenerating": "Membuat PDF...",
      "results.pdfSuccess": "PDF berhasil diunduh!",
      "results.pdfError": "Gagal membuat PDF",
      "results.archiveBtn": "Hapus Laporan ini",
      "results.archiveConfirm":
        "Hapus dari riwayat? Analisis tetap tersimpan di admin.",
      "results.archiveSuccess": "Analisis dihapus dari riwayat.",
      "results.suspicious": "MENCURIGAKAN",
      "results.makePublicFirst":
        "Aktifkan visibilitas publik terlebih dahulu sebelum berbagi tautan.",
      "results.shareIdMissing": "Share ID tidak tersedia",
      "results.shareTextFake":
        "Media ini terdeteksi memiliki RISIKO TINGGI dengan kepercayaan {{confidence}}% — dianalisis menggunakan Veriksa AI!",
      "results.shareTextOther":
        "Penilaian risiko selesai: {{verdict}} ({{confidence}}%) — lihat laporan lengkapnya di Veriksa AI!",
      "results.privacyToggleOwner":
        "Ini adalah laporan Anda — atur visibilitasnya di bawah",

      // ── Risk Level ───────────────────────────────────────────────────────
      "results.riskLevel": "Tingkat Risiko",
      "results.riskHigh": "Risiko Tinggi",
      "results.riskMedium": "Risiko Sedang",
      "results.riskLow": "Risiko Rendah",
      "results.riskUncertain": "Tidak Dapat Ditentukan",
      "results.riskHighDesc":
        "Terdapat indikator kuat bahwa konten ini bersifat AI-generated atau merupakan deepfake.",
      "results.riskMediumDesc":
        "Ditemukan beberapa indikator manipulasi, namun belum cukup untuk disimpulkan secara definitif.",
      "results.riskLowDesc":
        "Terdapat indikator kuat bahwa konten ini adalah asli dan tidak dimanipulasi.",
      "results.riskUncertainDesc":
        "Data yang tersedia tidak mencukupi untuk menentukan tingkat risiko secara pasti.",

      // ── Display Verdict Labels (risk-based, shown in UI) ──────────────────
      "results.displayFake": "RISIKO TINGGI",
      "results.displayReal": "RISIKO RENDAH",
      "results.displayUncertain": "TIDAK PASTI",
      "results.displayInsufficient": "SINYAL TIDAK CUKUP",
      "results.verdictDisclaimer":
        "Penilaian ini bersifat otomatis dan informatif, bukan keputusan forensik yang mengikat.",
      "results.downloadBadge": "Unduh Badge",

      // ── Recommendations ──────────────────────────────────────────────────
      "results.recommendations": "Rekomendasi",
      "results.noRecommendations": "Tidak ada rekomendasi tersedia.",
      "results.feedbackTitle": "Feedback Hasil",
      "results.feedbackQuestion": "Apakah hasil analisis ini akurat?",
      "results.feedbackCorrect": "Ya, akurat",
      "results.feedbackIncorrect": "Perlu koreksi",
      "results.feedbackHint":
        "Feedback membantu peningkatan kualitas model deteksi.",
      "results.feedbackSaved": "Feedback berhasil disimpan.",
      "results.feedbackError": "Gagal menyimpan feedback.",
      "results.feedbackCurrent": "Feedback Anda: {{value}}",
      "results.feedbackValue.correct": "Akurat",
      "results.feedbackValue.incorrect": "Perlu koreksi",

      // ── About ─────────────────────────────────────────────────────────────
      "about.tag": "Perusahaan",
      "about.title": "Tentang Veriksa",
      "about.desc":
        "Veriksa adalah platform deteksi deepfake berbasis AI yang dirancang khusus untuk konteks Indonesia. Kami membantu jurnalis, peneliti, kreator konten, dan masyarakat umum untuk memverifikasi keaslian media di era konten sintetis yang semakin canggih.",
      "about.mission.title": "Misi Kami",
      "about.mission.desc":
        "Membantu masyarakat Indonesia membedakan konten asli dari deepfake dan media yang dimanipulasi — cepat, akurat, dan mudah diakses.",
      "about.tech.title": "Teknologi",
      "about.tech.desc":
        "Menggunakan dua lapisan AI: satu untuk deteksi sinyal teknis, satu lagi untuk analisis naratif mendalam — keduanya bekerja secara komplementer untuk hasil terbaik.",
      "about.contact.title": "Kontak",
      "about.contact.desc": "Pertanyaan & kemitraan: hello@veriksa.id",
      "about.why.title": "Mengapa Veriksa?",
      "about.why.f1":
        "Analisis selesai dalam hitungan menit menggunakan model AI kelas enterprise",
      "about.why.f2":
        "Mendukung upload file dan analisis URL dari YouTube, TikTok, Instagram, dan lainnya",
      "about.why.f3":
        "Laporan forensik lengkap: wajah, temporal, pencahayaan, audio",
      "about.why.f4":
        "Harga terjangkau dalam IDR, tersedia paket gratis selamanya",
      "about.why.f5":
        "Data tidak pernah disimpan permanen — privasi Anda terjamin",
      "about.api.title": "API Access",
      "about.api.desc":
        "Akses API tersedia untuk pengguna paket Business. Dokumentasi API akan segera hadir.",
      "about.contactUs.title": "Hubungi Kami",
      "about.contactUs.email": "Email: hello@veriksa.id",
      "about.contactUs.security":
        "Untuk laporan kerentanan keamanan: security@veriksa.id",
      "about.links.pricing": "Lihat Harga →",
      "about.links.terms": "Syarat & Ketentuan",
      "about.links.privacy": "Privasi",

      "videos.archive": "Arsip Analisis",
      "videos.title": "Media",

      // ── Discover (Public Analysis Feed) ──────────────────────────────────────
      "discover.archive": "Laporan Publik",
      "discover.title": "Discover",
      "discover.untitled": "Tanpa Judul",
      "discover.reportBtn": "Laporkan konten ini",
      "discover.reported": "Dilaporkan",
      "discover.reportSent": "Laporan terkirim. Terima kasih.",
      "discover.flagReasonTitle": "Pilih Alasan",
      "discover.flagReason.misleading": "Verdikt terasa menyesatkan",
      "discover.flagReason.inappropriate": "Konten tidak pantas",
      "discover.flagReason.duplicate": "Laporan duplikat",
      "discover.flagReason.hoax": "Digunakan untuk menyebarkan hoaks",
      "discover.flagReason.other": "Lainnya",
      "discover.flagDetailsPlaceholder": "Detail (opsional, maks 200 karakter)",
      "discover.flagSubmit": "Kirim Laporan",
      "discover.searchPlaceholder": "Cari judul atau deskripsi...",
      "discover.subtitle":
        "Laporan analisis yang dipublikasikan oleh komunitas Veriksa. Total",
      "discover.public": "laporan publik.",
      "discover.analyzeBtn": "Analisis Media Anda",
      "discover.empty.title": "Belum ada laporan publik",
      "discover.empty.text":
        "Jadilah yang pertama menganalisis dan membagikan hasilnya ke komunitas!",
      "discover.empty.cta": "Mulai Gratis",
      "discover.card.view": "Lihat",
      "discover.media.all": "Semua",
      "discover.media.video": "Video",
      "discover.media.image": "Gambar",
      "discover.media.audio": "Audio",
      "discover.dateRange": "Rentang Tanggal",
      "discover.dateFrom": "Dari",
      "discover.dateTo": "Sampai",
      "discover.applyFilter": "Terapkan",
      "discover.prev": "Sebelumnya",
      "discover.next": "Berikutnya",
      "discover.cta.title": "Temukan sesuatu yang mencurigakan?",
      "discover.cta.desc":
        "Analisis dengan Veriksa dan bagikan hasilnya ke komunitas. Gratis untuk 3 analisis pertama.",
      "discover.cta.btn": "Mulai Gratis",
      "videos.subtitle":
        "Laporan analisis yang telah dipublikasikan oleh komunitas Veriksa.",
      "videos.public": "laporan publik",
      "videos.analyzeBtn": "Analisis Media Anda",
      "videos.empty.title": "Belum ada laporan publik",
      "videos.empty.text":
        "Jadilah yang pertama menganalisis dan membagikan hasilnya ke komunitas!",
      "videos.empty.cta": "Mulai Gratis",
      "videos.card.view": "Lihat",
      "videos.sort.newest": "Terbaru",
      "videos.sort.trending": "Trending",
      "videos.sort.mostViews": "Paling Dilihat",
      "videos.sort.popular": "Populer",
      "videos.filter.all": "Semua",
      "videos.filter.deepfake": "Deepfake",
      "videos.filter.real": "Asli",
      "videos.filter.uncertain": "Tidak Pasti",
      "videos.prev": "Sebelumnya",
      "videos.next": "Berikutnya",
      "videos.userFallback": "Pengguna Veriksa",
      "videos.cta.title": "Punya video yang mencurigakan?",
      "videos.cta.desc":
        "Analisis dengan Veriksa dan bagikan hasilnya ke komunitas. Gratis untuk 3 video pertama.",
      "videos.cta.btn": "Mulai Gratis",

      // ── Dashboard ──────────────────────────────────────────────────────────
      "dashboard.title": "Dashboard",
      "dashboard.welcome": "Selamat datang,",
      "dashboard.usage.title": "Pemakaian Bulan Ini",
      "dashboard.usage.remaining": "Sisa bulan ini",
      "dashboard.usage.daily": "Limit harian",
      "dashboard.usage.fileLimit": "Maks. ukuran file",
      "dashboard.usage.reset": "Reset kuota",
      "dashboard.usage.analyses": "analisis",
      "dashboard.usage.perDay": "/hari",
      "dashboard.plan.title": "Paket Saat Ini",
      "dashboard.plan.perMonth": "analisis/bulan",
      "dashboard.plan.unlimited": "Tidak Terbatas",
      "dashboard.plan.paymentHistory": "Riwayat pembayaran",
      "dashboard.plan.upgrade": "Upgrade Paket",
      "dashboard.plan.change": "Ubah Paket",
      "dashboard.plan.recurring": "Langganan Otomatis",
      "dashboard.plan.recurringActive":
        "Aktif — diperpanjang otomatis setiap bulan",
      "dashboard.plan.recurringFailed":
        "Pembayaran gagal — perbarui metode pembayaran",
      "dashboard.plan.recurringPending":
        "Menunggu aktivasi — selesaikan pembayaran",
      "dashboard.plan.nextCharge": "Tagihan berikutnya",
      "dashboard.plan.label.free": "Free",
      "dashboard.plan.label.starter": "Starter",
      "dashboard.plan.label.pro": "Pro",
      "dashboard.plan.label.business": "Business",
      "dashboard.plan.label.unlimited": "Unlimited",
      "dashboard.plan.cancelSub": "Batalkan Langganan",
      "dashboard.plan.cancelConfirm":
        "Yakin ingin membatalkan langganan? Akses premium akan tetap aktif hingga akhir periode, lalu beralih ke paket Free.",
      "dashboard.plan.cancelSuccess":
        "Pembatalan dijadwalkan. Paket akan kembali ke Free di akhir periode aktif.",
      "dashboard.plan.trialActive": "Trial — {{days}} hari tersisa",
      "dashboard.plan.trialExpired": "Masa trial telah berakhir",
      "subscription.title": "Langganan",
      "subscription.subtitle":
        "Kelola paket aktif, upgrade, downgrade, dan pembatalan langganan Anda.",
      "subscription.currentPlan": "Paket Saat Ini",
      "subscription.resetAt": "Reset kuota berikutnya: {{date}}",
      "subscription.pendingDowngrade":
        "Downgrade ke paket {{plan}} dijadwalkan pada {{date}}.",
      "subscription.managePlans": "Kelola Paket",
      "subscription.howTo": "Alur Upgrade / Downgrade",
      "subscription.step.upgrade":
        "Upgrade paket melalui halaman Harga. Upgrade berlaku langsung setelah pembayaran sukses.",
      "subscription.step.downgrade":
        "Downgrade dijadwalkan ke akhir periode aktif agar akses paket saat ini tetap aman.",
      "subscription.step.cancel":
        "Batalkan langganan jika diperlukan. Akun akan kembali ke paket Free sesuai kebijakan sistem.",
      "subscription.loadFailed": "Gagal memuat status langganan.",
      "dashboard.refresh": "Segarkan data",
      "dashboard.quickAction.title": "Mulai Analisis Baru",
      "dashboard.quickAction.desc":
        "Unggah media atau tempel URL untuk penilaian risiko AI secara instan.",
      "dashboard.quickAction.btn": "Analisis Baru",
      "dashboard.recent.title": "Analisis Terbaru",
      "dashboard.recent.seeAll": "Lihat semua",
      "dashboard.recent.empty": "Belum ada analisis.",
      "dashboard.recent.first": "Mulai analisis pertama Anda",
      "dashboard.recent.colThumbnail": "Thumbnail",
      "dashboard.recent.colContent": "Judul & Ringkasan",
      "dashboard.recent.colScore": "Skor Risiko",
      "dashboard.recent.colDate": "Tanggal Analisis",
      "dashboard.recent.noExcerpt": "Ringkasan belum tersedia.",
      "dashboard.recent.untitled": "Tanpa judul",
      "dashboard.warning.near": "Kuota Anda hampir habis",
      "dashboard.warning.nearDetail":
        "Kuota hampir habis ({{used}}/{{limit}}).",
      "dashboard.warning.full": "Kuota bulan ini telah habis. Reset pada",
      "dashboard.warning.fullDetail":
        "Kuota bulan ini habis. Reset pada {{date}}.",
      "dashboard.warning.upgrade": "Upgrade sekarang",
      "dashboard.warning.upgradeToContinue": "Upgrade untuk lanjutkan",
      "dashboard.verify.title": "Memverifikasi pembayaran...",
      "dashboard.verify.desc":
        "Mohon tunggu sebentar, sedang memperbarui paket Anda.",
      "dashboard.verify.failed.title": "Pembayaran tercatat di Midtrans",
      "dashboard.verify.failed.desc":
        "Sistem sedang menyinkronkan status pembayaran. Silakan klik verifikasi ulang.",
      "dashboard.verify.btn": "Verifikasi Ulang",
      "dashboard.payment.success":
        "Pembayaran berhasil! Paket Anda telah diupgrade.",
      "dashboard.payment.pending": "Pembayaran sedang menunggu penyelesaian.",
      "dashboard.payment.failed": "Pembayaran gagal atau kedaluwarsa.",
      "dashboard.payment.trialActive": "Paket aktif.",
      "dashboard.credits.title": "Kredit Analisis",
      "dashboard.credits.balance": "Saldo Kredit",
      "dashboard.credits.buy": "Beli Kredit",
      "dashboard.credits.expires": "Berlaku hingga",
      "dashboard.credits.empty": "Tidak ada kredit aktif",
      "dashboard.credits.unit": "kredit",
      "dashboard.credits.success": "Kredit berhasil ditambahkan!",
      "dashboard.credits.pending": "Menunggu pembayaran kredit...",
      "dashboard.credits.failed": "Pembayaran kredit gagal.",

      // ── Pricing ────────────────────────────────────────────────────────────
      "pricing.badge": "Harga",
      "pricing.title": "Pilih Paket Veriksa Sesuai Kebutuhan",
      "pricing.subtitle":
        "Mulai dari paket Free, lalu upgrade saat kebutuhan analisis Anda bertambah.",
      "pricing.popular": "Paling Populer",
      "pricing.current": "Aktif",
      "pricing.perMonth": "/bulan",
      "pricing.free": "Gratis",
      "pricing.plan.free": "Free",
      "pricing.plan.starter": "Starter",
      "pricing.plan.pro": "Pro",
      "pricing.plan.business": "Business",
      "pricing.unlimited": "Analisis tidak terbatas",
      "pricing.analyses": "analisis/bulan",
      "pricing.cta.free": "Mulai Gratis",
      "pricing.trialBadge": "7 hari gratis!",
      "pricing.trialActivated":
        "Trial {{days}} hari aktif! Selamat menikmati fitur premium.",
      "pricing.loginRequired": "Silakan login untuk upgrade",
      "pricing.cta.upgrade": "Upgrade ke",
      "pricing.cta.downgrade": "Downgrade ke",
      "pricing.confirmDowngrade":
        "Yakin ingin menurunkan paket? Perubahan akan berlaku setelah periode langganan saat ini berakhir.",
      "pricing.downgradeScheduled":
        "Downgrade dijadwalkan. Berlaku mulai {{effectiveDate}}.",
      "pricing.cta.current": "Paket Aktif",
      "pricing.processing": "Memproses...",
      "pricing.compare.show": "Lihat perbandingan fitur lengkap",
      "pricing.compare.hide": "Sembunyikan perbandingan fitur lengkap",
      "pricing.compare.link": "Lihat perbandingan fitur lengkap",
      "pricing.compare.detailTitle": "Perbandingan Fitur Lengkap",
      "pricing.compare.detailSubtitle":
        "Bandingkan fitur setiap paket agar mudah memilih yang paling sesuai untuk kebutuhan Anda.",
      "pricing.compare.col.feature": "Fitur",
      "pricing.compare.row.monthlyLimit": "Analisis / bulan",
      "pricing.compare.row.dailyLimit": "Maks analisis / hari",
      "pricing.compare.row.fileLimit": "Upload max size",
      "pricing.compare.row.cooldown": "Cooldown",
      "pricing.compare.row.maxVideoDuration": "Maks durasi video",
      "pricing.compare.row.maxAudioDuration": "Maks durasi audio",
      "pricing.compare.row.gracePeriod":
        "Masa aktif setelah berhenti langganan",
      "pricing.compare.row.aiExplain": "Penjelasan AI",
      "pricing.compare.row.reportLanguages": "Bahasa laporan",
      "pricing.compare.tooltip.ai.noneLabel": "Tidak ada:",
      "pricing.compare.tooltip.ai.noneDesc": "tanpa ringkasan AI.",
      "pricing.compare.tooltip.ai.basicLabel": "Basic:",
      "pricing.compare.tooltip.ai.basicDesc": "ringkasan inti.",
      "pricing.compare.tooltip.ai.fullLabel": "Lengkap:",
      "pricing.compare.tooltip.ai.fullDesc": "ringkasan plus konteks teknis.",
      "pricing.compare.tooltip.reportTechnical":
        "Jika aktif, laporan menampilkan detail teknis tambahan (artefak, indikator, dan konteks analisis).",
      "pricing.compare.tooltip.label": "Lihat penjelasan",
      "pricing.compare.row.emailSupport": "Email support",
      "pricing.compare.value.basic": "Basic",
      "pricing.compare.value.full": "Lengkap",
      "pricing.compare.value.notAvailable": "Tidak tersedia",
      "pricing.compare.value.seconds": "{{count}} detik",
      "pricing.compare.value.days": "{{count}} hari",
      "pricing.compare.value.minutes": "{{value}} menit",
      "pricing.compare.value.unlimited": "Tanpa batas",
      "pricing.lang.id": "ID",
      "pricing.lang.en": "EN",
      "pricing.billing.monthly": "Bulanan",
      "pricing.billing.annual": "Tahunan",
      "pricing.billing.annualSave": "Hemat {{value}} / tahun",
      "pricing.billing.yearlyBilled": "Ditagih tahunan",
      "pricing.billing.discountInfoPercent": "Diskon tahunan {{value}}%",
      "pricing.billing.discountInfoNominal": "Diskon tahunan {{value}}",
      "pricing.billing.discountOff": "Diskon tahunan nonaktif",
      "pricing.loadPlansFailed": "Gagal memuat daftar paket.",
      "pricing.noPaidPlans":
        "Belum ada paket berbayar publik yang aktif saat ini.",
      "pricing.paymentSuccess": "Pembayaran berhasil!",
      "pricing.paymentPending": "Menunggu pembayaran...",
      "pricing.paymentFailed": "Pembayaran gagal.",
      "pricing.checkoutFailed": "Gagal memulai checkout.",
      "pricing.snapUnavailable": "Midtrans Snap belum siap. Silakan coba lagi.",
      "pricing.credit.pending": "Menunggu pembayaran kredit...",
      "pricing.credit.failed": "Pembayaran kredit gagal.",
      "pricing.footer":
        "Pembayaran diproses aman oleh Midtrans · QRIS, GoPay, ShopeePay, Bank Transfer · Batalkan kapan saja",
      "pricing.login.required": "Login diperlukan untuk upgrade",
      "pricing.redirect": "Mengarahkan ke halaman pembayaran...",
      "pricing.sec.quota": "Kuota & Limit",
      "pricing.sec.detect": "Deteksi",
      "pricing.sec.report": "Laporan",
      "pricing.sec.storage": "Penyimpanan",
      "pricing.sec.support": "Support",
      "pricing.feat.soon": "SEGERA HADIR",
      "pricing.feat.quota.monthly": "{{count}} analisis / bulan",
      "pricing.feat.quota.daily": "Maks. {{count}} analisis / hari",
      "pricing.feat.quota.file": "Upload file maks. {{size}}",
      "pricing.feat.quota.cooldown": "Cooldown {{seconds}} detik",
      "pricing.feat.quota.maxVideoDuration": "Durasi video: {{value}}",
      "pricing.feat.quota.maxAudioDuration": "Durasi audio: {{value}}",
      "pricing.feat.detect.all": "Gambar, video & audio",
      "pricing.feat.detect.image": "Gambar / Foto",
      "pricing.feat.detect.video": "Video",
      "pricing.feat.detect.audio": "Audio",
      "pricing.feat.report.score": "Skor deteksi deepfake",
      "pricing.feat.report.aiBasic": "Penjelasan AI ringkas",
      "pricing.feat.report.aiFull": "Penjelasan AI lengkap",
      "pricing.feat.report.bilingual": "Laporan bilingual (ID/EN)",
      "pricing.feat.report.languages": "Bahasa laporan: {{value}}",
      "pricing.feat.report.technical": "Laporan teknis detail",
      "pricing.feat.report.pdf": "Unduh laporan PDF",
      "pricing.feat.storage.historyFree": "Riwayat analisis tersimpan",
      "pricing.feat.storage.history": "Riwayat hasil analisis tersimpan",
      "pricing.feat.storage.upload": "Bisa upload file untuk dianalisis",
      "pricing.feat.storage.files":
        "Media asli diproses sementara (tidak disimpan permanen)",
      "pricing.feat.storage.grace": "Masa tenggang paket berbayar 7 hari",
      "pricing.feat.storage.graceDays":
        "Paket tetap aktif {{days}} hari setelah berhenti langganan",
      "pricing.feat.storage.credits": "Top up kredit saat kuota habis",
      "pricing.feat.support.center": "Pusat bantuan",
      "pricing.feat.support.api": "Akses API",
      "pricing.feat.support.emailHours": "Email support ({{hours}} jam)",
      "pricing.feat.free.q1": "3 analisis / bulan",
      "pricing.feat.free.q2": "Maks. 1 analisis / hari",
      "pricing.feat.free.q3": "Upload file maks. 50 MB",
      "pricing.feat.starter.q1": "25 analisis / bulan",
      "pricing.feat.starter.q2": "Maks. 5 analisis / hari",
      "pricing.feat.starter.q3": "Upload file maks. 200 MB",
      "pricing.feat.starter.q4": "Cooldown 30 detik",
      "pricing.feat.starter.email": "Email support (48 jam)",
      "pricing.feat.pro.q1": "80 analisis / bulan",
      "pricing.feat.pro.q2": "Maks. 15 analisis / hari",
      "pricing.feat.pro.q3": "Upload file maks. 500 MB",
      "pricing.feat.pro.q4": "Cooldown 15 detik",
      "pricing.feat.pro.email": "Email support (24 jam)",
      "pricing.feat.business.q1": "250 analisis / bulan",
      "pricing.feat.business.q2": "Maks. 40 analisis / hari",
      "pricing.feat.business.q3": "Upload file maks. 1 GB",
      "pricing.feat.business.q4": "Cooldown 5 detik",
      "pricing.feat.business.email": "Email support prioritas (12 jam)",
      "pricing.trust.encrypted": "Enkripsi saat transfer & penyimpanan",
      "pricing.trust.server": "Server Singapura",
      "pricing.trust.pdp": "Sesuai UU PDP Indonesia",
      "pricing.trust.payment": "Pembayaran via Midtrans",
      "pricing.trial.title": "Coba gratis 7 hari — tanpa kartu kredit",
      "pricing.trial.desc": "Akses semua fitur Starter. Sekali per akun.",
      "pricing.trial.cta": "Mulai Trial Gratis",
      "pricing.credit.title": "Paket Kredit",
      "pricing.credit.subtitle":
        "Lanjutkan analisis saat kuota bulanan habis: foto 1 kredit, audio 2 kredit, video 3 kredit. Kredit tambahan tidak kedaluwarsa.",
      "pricing.credit.image": "Gambar / Foto",
      "pricing.credit.video": "Video",
      "pricing.credit.audio": "Audio",
      "pricing.credit.buy": "Beli Kredit",
      "pricing.credit.perCredit": "/ kredit",
      "pricing.credit.perAnalysis": "1 kredit / analisis",
      "pricing.credit.bestseller": "Terlaris",
      "pricing.credit.unit": "kredit",
      "pricing.credit.1credit": "1 kredit",
      "pricing.credit.3credits": "3 kredit",
      "pricing.credit.2credits": "2 kredit",
      "pricing.retention.title": "Kebijakan Penyimpanan Data",
      "pricing.retention.col.data": "Data",
      "pricing.retention.col.policy": "Kebijakan",
      "pricing.retention.r1.data": "Hasil analisis (skor & laporan teks)",
      "pricing.retention.r1.policy":
        "Tersimpan hingga Anda arsipkan dari akun Anda",
      "pricing.retention.r2.data": "Media upload asli",
      "pricing.retention.r2.policy":
        "Diproses sementara untuk analisis dan tidak disimpan permanen",
      "pricing.retention.r3.data": "Thumbnail / preview analisis",
      "pricing.retention.r3.policy":
        "Disimpan sebagai bagian dari riwayat hasil analisis",
      "pricing.retention.r4.data": "Masa tenggang paket berbayar",
      "pricing.retention.r4.policy":
        "7 hari sebelum paket otomatis kembali ke Free",
      "pricing.retention.r5.data": "Kredit tambahan",
      "pricing.retention.r5.policy": "Tidak kadaluarsa",
      "pricing.faq.title": "Pertanyaan Umum",
      "pricing.faq.q1": "Apa itu kredit dan bagaimana cara kerjanya?",
      "pricing.faq.a1":
        "Kredit adalah saldo tambahan yang dipakai ketika kuota bulanan paket Anda habis. Saat kuota habis, setiap analisis menggunakan 1 kredit. Kredit yang dibeli via paket kredit tidak kadaluarsa.",
      "pricing.faq.q2": "Apa yang terjadi jika kredit bulanan saya habis?",
      "pricing.faq.a2":
        "Anda bisa membeli paket kredit tambahan kapan saja tanpa harus upgrade paket. Alternatifnya, upgrade ke paket lebih tinggi agar kuota bulanan lebih besar.",
      "pricing.faq.q3": "Bisakah saya membatalkan langganan kapan saja?",
      "pricing.faq.a3":
        "Ya. Langganan tetap aktif sampai akhir periode yang sudah dibayar. Setelah periode berakhir, paket berbayar memiliki masa tenggang 7 hari sebelum kembali ke paket Free.",
      "pricing.faq.q4": "Metode pembayaran apa yang diterima?",
      "pricing.faq.a4":
        "Kami menerima QRIS (GoPay, OVO, DANA, LinkAja, ShopeePay), transfer bank (BCA, BNI, BRI, Mandiri), kartu kredit/debit, dan pembayaran di minimarket (Indomaret, Alfamart). Semua transaksi diproses aman melalui Midtrans.",
      "pricing.faq.q5": "Apakah data saya aman?",
      "pricing.faq.a5":
        "Semua file dienkripsi saat transfer dan penyimpanan. Server berlokasi di Asia Tenggara untuk latensi rendah ke Indonesia. Kami mematuhi UU Perlindungan Data Pribadi (UU PDP) Indonesia.",
      "pricing.cta.title": "Siap mendeteksi deepfake?",
      "pricing.cta.desc":
        "Mulai dengan trial gratis 7 hari. Tanpa kartu kredit, tanpa risiko.",
      "pricing.cta.btn": "Coba Veriksa Gratis",
      "pricing.cta.freeNow": "Mulai Sekarang - Gratis",

      // ── Maintenance ─────────────────────────────────────────────────────
      "maintenance.badge": "Maintenance Mode",
      "maintenance.title": "Sistem Sedang Dalam Pemeliharaan",
      "maintenance.desc":
        "Kami sedang melakukan pemeliharaan sistem untuk meningkatkan layanan. Silakan kembali beberapa saat lagi.",
      "maintenance.validating": "Memvalidasi token bypass...",
      "maintenance.bypassActive": "Bypass Aktif — Login Admin",
      "maintenance.otpSent": "Kode OTP telah dikirim ke email Anda.",
      "maintenance.adminOnly": "Akses tidak diizinkan.",
      "maintenance.tokenInvalid": "Token tidak valid",
      "maintenance.loginFailed": "Login gagal",
      "maintenance.otpFailed": "Verifikasi OTP gagal",
      "maintenance.emailPlaceholder": "Admin email",
      "maintenance.passwordPlaceholder": "Password",
      "maintenance.otpPlaceholder": "Masukkan kode OTP",
      "maintenance.signIn": "Sign In",
      "maintenance.verifyOtp": "Verify OTP",
      "history.title": "Riwayat Analisis",
      "history.archive": "Arsip Forensik",
      "history.stored": "{{count}} laporan tersimpan",
      "history.subtitle": "Semua hasil analisis Anda tersimpan di sini.",
      "history.empty": "Belum ada analisis.",
      "history.empty.desc": "Mulai analisis media pertama Anda sekarang.",
      "history.empty.btn": "Analisis Sekarang",
      "history.loadError": "Gagal memuat riwayat",
      "history.deleteSuccess": "Dihapus: {{name}}",
      "history.deleteError": "Gagal menghapus analisis",
      "history.delete.confirm": "Hapus analisis ini?",
      "history.delete.success": "Analisis dihapus",
      "history.date": "Tanggal",
      "history.verdict": "Hasil",
      "history.confidence": "Kepercayaan",
      "history.model": "Model",
      "history.view": "Lihat",
      "history.filter.all": "Semua",
      "history.filter.real": "Asli",
      "history.filter.fake": "Palsu",
      "history.filter.uncertain": "Tidak Pasti",
      "history.search.placeholder": "Cari judul atau deskripsi...",
      "history.search.btn": "Cari",
      "history.clearFilters": "Hapus Filter",
      "history.verdictFilter.all": "Semua Hasil",
      "history.verdictFilter.fake": "Risiko Tinggi",
      "history.verdictFilter.real": "Risiko Rendah",
      "history.verdictFilter.suspicious": "Tidak Pasti",
      "history.verdictFilter.uncertain": "Tidak Pasti",
      "history.mediaFilter.all": "Semua Media",
      "history.mediaFilter.video": "Video",
      "history.mediaFilter.image": "Gambar",
      "history.mediaFilter.audio": "Audio",
      "history.dateRange": "Rentang Tanggal",
      "history.dateFrom": "Dari",
      "history.dateTo": "Sampai",
      "history.applyFilter": "Terapkan",
      "history.reset": "Reset",
      "history.prev": "Sebelumnya",
      "history.next": "Berikutnya",
      "history.page": "{{page}} / {{pages}}",
      "history.resetCount": "Reset ({{count}})",

      // ── Payment History ────────────────────────────────────────────────────
      "payment.title": "Riwayat Pembayaran",
      "payment.subtitle": "Semua transaksi dan riwayat upgrade paket Anda.",
      "payment.empty": "Belum ada riwayat pembayaran.",
      "payment.empty.cta": "Lihat Paket",
      "payment.summary.total": "Total Transaksi",
      "payment.summary.success": "Berhasil",
      "payment.summary.paid": "Total Dibayar",
      "payment.summary.active": "Paket Aktif",
      "payment.status.paid": "Berhasil",
      "payment.status.pending": "Menunggu",
      "payment.status.failed": "Gagal",
      "payment.complete": "Selesaikan pembayaran",
      "payment.plan": "Paket",

      // ── Profile ────────────────────────────────────────────────────────────
      "profile.title": "Edit Profil",
      "profile.subtitle": "Atur informasi dan preferensi akun Anda.",
      "profile.name": "Nama Lengkap",
      "profile.email": "Email",
      "profile.email.hint": "Email tidak dapat diubah",
      "profile.picture": "Foto Profil (URL)",
      "profile.picture.hint": "Masukkan URL gambar publik",
      "profile.language": "Bahasa",
      "profile.language.id": "Indonesia",
      "profile.language.en": "English",
      "profile.save": "Simpan Perubahan",
      "profile.saved": "Profil berhasil disimpan!",
      "profile.password.title": "Ubah Password",
      "profile.password.old": "Password Lama",
      "profile.password.new": "Password Baru",
      "profile.password.hint": "Minimal 8 karakter",
      "profile.password.save": "Ubah Password",
      "profile.password.success": "Password berhasil diubah!",
      "profile.google.hint":
        "Akun Google tidak dapat mengubah password di sini.",
      "profile.plan": "Paket",
      "profile.member.since": "Bergabung sejak",
      "profile.recharge.title": "Auto-Recharge Kredit",

      // Notifications
      "profile.notifications.title": "Notifikasi",
      "profile.notifications.label": "Push Notification",
      "profile.notifications.desc":
        "Terima notifikasi saat analisis selesai, kuota hampir habis, atau pembayaran berhasil.",
      "profile.notifications.enable": "Aktifkan",
      "profile.notifications.active": "Aktif",
      "profile.notifications.enabled": "Notifikasi diaktifkan",
      "profile.notifications.denied": "Diblokir",
      "profile.notifications.deniedHint": "Ubah di pengaturan browser",
      "profile.notifications.blocked":
        "Notifikasi diblokir oleh browser. Ubah di pengaturan browser Anda.",
      "profile.notifications.disable": "Nonaktifkan",
      "profile.notifications.disabled": "Notifikasi dinonaktifkan",
      "profile.training.title": "Kontribusi Data Pelatihan AI",
      "profile.training.label":
        "Izinkan data analisis dipakai untuk peningkatan model",
      "profile.training.desc":
        "Opsional. Hanya hasil yang Anda izinkan yang dapat dipakai untuk riset peningkatan akurasi model. Anda bisa mematikan kapan saja.",
      "profile.training.on": "Kontribusi data AI diaktifkan",
      "profile.training.off": "Kontribusi data AI dinonaktifkan",
      "profile.training.save": "Simpan Preferensi",
      "profile.training.saving": "Menyimpan...",
      "profile.training.updatedAt": "Diperbarui: {{date}}",
      "profile.training.error": "Gagal menyimpan preferensi kontribusi data",
      "profile.recharge.label": "Isi ulang kredit otomatis",
      "profile.recharge.desc":
        "Saat kuota bulanan habis, sistem akan otomatis membeli kredit tambahan menggunakan metode pembayaran Anda.",
      "profile.recharge.typeLabel": "Tipe Recharge",
      "profile.recharge.package": "Pilih Paket",
      "profile.recharge.custom": "Nominal Bebas",
      "profile.recharge.selectPack": "Pilih Paket",
      "profile.recharge.credits": "kredit",
      "profile.recharge.nominalLabel": "Nominal (IDR)",
      "profile.recharge.nominalMin": "Min. Rp 10.000 - Maks. Rp 1.000.000",
      "profile.recharge.nominalError": "Nominal minimal Rp 10.000",
      "profile.recharge.save": "Simpan Pengaturan",
      "profile.recharge.saving": "Menyimpan...",
      "profile.recharge.on": "Auto-recharge diaktifkan",
      "profile.recharge.off": "Auto-recharge dinonaktifkan",
      "profile.recharge.error": "Gagal mengubah pengaturan",
      "profile.recharge.statusPackage":
        "Auto-recharge: {{credits}} kredit (Rp {{price}}) saat kuota habis.",
      "profile.recharge.statusCustom":
        "Auto-recharge: Rp {{amount}} saat kuota habis.",

      // ── Forgot Password ────────────────────────────────────────────────────
      "forgot.title": "Lupa Password",
      "forgot.desc":
        "Masukkan alamat email Anda untuk menerima kode verifikasi.",
      "forgot.step.email": "Email",
      "forgot.step.verify": "Verifikasi",
      "forgot.step.newPw": "Password Baru",
      "forgot.email.label": "Alamat Email",
      "forgot.email.submit": "Kirim Kode OTP",
      "forgot.email.sending": "Mengirim...",
      "forgot.email.success": "Kode OTP dikirim ke email Anda",
      "forgot.email.error": "Gagal mengirim OTP",
      "forgot.otp.title": "Verifikasi OTP",
      "forgot.otp.desc": "Masukkan kode 6 digit yang dikirim ke email Anda.",
      "forgot.otp.label": "Kode OTP (6 digit)",
      "forgot.otp.submit": "Verifikasi",
      "forgot.otp.verifying": "Memverifikasi...",
      "forgot.otp.error": "OTP tidak valid",
      "forgot.otp.resend": "Kirim ulang OTP",
      "forgot.otp.resending": "Mengirim...",
      "forgot.otp.resendError": "Gagal kirim ulang",
      "forgot.reset.title": "Buat Password Baru",
      "forgot.reset.desc": "Buat password baru minimal 8 karakter.",
      "forgot.reset.label": "Password Baru",
      "forgot.reset.confirm": "Konfirmasi Password",
      "forgot.reset.submit": "Simpan Password Baru",
      "forgot.reset.saving": "Menyimpan...",
      "forgot.reset.success":
        "Password baru berhasil disimpan! Silakan masuk dengan password baru Anda.",
      "forgot.reset.error": "Gagal mereset password",
      "forgot.back": "Kembali ke login",

      // ── Register Hero ──────────────────────────────────────────────────────
      "register.hero.badge": "Analisis Risiko Media",
      "register.hero.title": "Lindungi Diri dari\nManipulasi Media Digital",
      "register.hero.desc":
        "Daftar gratis dan mulai verifikasi media dengan teknologi AI forensik terdepan. Tanpa kartu kredit.",
      "register.hero.f1": "Deteksi deepfake bertenaga AI generasi terkini",
      "register.hero.f2":
        "Dukungan berbagai format media & URL platform sosial",
      "register.hero.f3":
        "Laporan forensik detail lengkap dengan confidence score",
      "register.hero.footer": "© 2026 Veriksa · Powered by Gemini 2.5 Pro",
      "register.otp.title": "Verifikasi Email",
      "register.otp.desc": "Kode dikirim ke",
      "register.otp.label": "Kode OTP (6 digit)",
      "register.otp.submit": "Verifikasi & Daftar",
      "register.otp.verifying": "Memverifikasi...",
      "register.otp.resend": "Kirim ulang OTP",
      "register.otp.resending": "Mengirim...",
      "register.otp.back": "Kembali ke form pendaftaran",
      "register.otp.sent": "Kode verifikasi dikirim ke email Anda",
      "register.otp.error": "Registrasi gagal",
      "register.otp.invalid": "OTP tidak valid",
      "register.otp.resent": "OTP baru dikirim!",
      "register.otp.resendError": "Gagal mengirim ulang OTP",

      // ── Analyze Extra ─────────────────────────────────────────────────────
      "analyze.tip.best":
        "Klip pendek (< 3 menit) dengan wajah jelas memberikan hasil terbaik.",
      "analyze.tip.accuracy":
        "Media resolusi tinggi meningkatkan akurasi deteksi.",
      "analyze.tip.privacy":
        "Media diproses sementara & dihapus otomatis setelah analisis selesai.",
      "analyze.tip.bestLabel": "Hasil terbaik",
      "analyze.tip.accuracyLabel": "Akurasi",
      "analyze.tip.privacyLabel": "Privasi",
      "analyze.autoRecharge.toast":
        "Kuota habis — pembayaran auto-recharge disiapkan...",
      "analyze.autoRecharge.title": "Auto-Recharge Disiapkan",
      "analyze.autoRecharge.desc":
        "{{credits}} kredit (Rp {{amount}}) sedang menunggu pembayaran. Setelah bayar, kredit langsung aktif.",
      "analyze.autoRecharge.pay": "Bayar Sekarang",
      "analyze.autoRecharge.dismiss": "Tutup",

      // ── Admin Email Blast ────────────────────────────────────────────────
      "admin.blast.title": "Email Blast",
      "admin.blast.subtitle": "Kirim email massal ke segmen user tertentu.",
      "admin.blast.compose": "Compose Email",
      "admin.blast.subject": "Subject",
      "admin.blast.subjectPlaceholder": "Pengumuman penting dari Veriksa",
      "admin.blast.message": "Pesan",
      "admin.blast.messagePlaceholder": "Tulis pesan di sini...",
      "admin.blast.target": "Target Penerima",
      "admin.blast.targetAll": "Semua User",
      "admin.blast.targetFree": "Free Plan",
      "admin.blast.targetPaid": "Paid Users (Starter/Pro/Business)",
      "admin.blast.targetAdmin": "Admin Only",
      "admin.blast.send": "Kirim",
      "admin.blast.sending": "Mengirim...",
      "admin.blast.sendSuccess": "Email diantrikan ke {{count}} user!",
      "admin.blast.sendError": "Gagal mengirim blast",
      "admin.blast.sandboxNote":
        "Sandbox Mailtrap: maks. 1 email/10 detik. Production: gunakan Mailtrap Email Delivery.",
      "admin.blast.history": "Riwayat Blast",
      "admin.blast.noHistory": "Belum ada riwayat blast",
      "admin.blast.clickDetail": "Klik untuk detail",
      "admin.blast.sent": "terkirim",
      "admin.blast.failed": "gagal",
      "admin.blast.detailError": "Gagal memuat detail blast",
      "admin.blast.subjectRequired": "Subject dan pesan wajib diisi",
      "admin.blast.detailMessage": "Pesan",
      "admin.blast.detailAll": "Semua",
      "admin.blast.detailNoRecipient": "Tidak ada penerima",
      "admin.digest.title": "Weekly Digest",
      "admin.digest.desc":
        "Ringkasan mingguan dikirim otomatis setiap Senin 09:00 WIB. Bisa juga trigger manual.",
      "admin.digest.send": "Kirim Sekarang",
      "admin.digest.sending": "Mengirim...",
      "admin.digest.success": "Weekly digest sedang dikirim di background!",
      "admin.digest.error": "Gagal mengirim digest",
      "admin.digest.date": "Tanggal",
      "admin.digest.sent": "Terkirim",
      "admin.digest.failed": "Gagal",
      "admin.digest.total": "Total User",

      // ── Admin Finance ─────────────────────────────────────────────────────
      "admin.finance.title": "Finance",
      "admin.finance.period": "Periode",
      "admin.finance.revenue": "Pendapatan",
      "admin.finance.cogs": "HPP (Gemini AI)",
      "admin.finance.grossProfit": "Laba Kotor",
      "admin.finance.margin": "Margin",
      "admin.finance.today": "Hari Ini",
      "admin.finance.analyses": "analisis",
      "admin.finance.transactions": "transaksi",
      "admin.finance.profitStatus": "UNTUNG",
      "admin.finance.lossStatus": "RUGI",
      "admin.finance.trend": "Tren Pendapatan vs Biaya",
      "admin.finance.byType": "Pendapatan per Tipe",
      "admin.finance.byPlan": "Pendapatan per Paket",
      "admin.finance.noData": "Belum ada data untuk periode ini",

      // ── Admin System ──────────────────────────────────────────────────────
      "admin.system.title": "System",
      "admin.system.subtitle":
        "Monitor kesehatan API dan konfigurasi platform.",
      "admin.system.health": "API Health",
      "admin.system.config": "Platform Config",
      "admin.system.maintenance": "Maintenance Mode",
      "admin.system.maintenanceDesc":
        "Nonaktifkan semua akses user ke platform. Admin masih bisa login.",
      "admin.system.registration": "User Registration",
      "admin.system.registrationDesc":
        "Izinkan user baru mendaftar ke Veriksa.",
      "admin.system.refresh": "Refresh",
      "admin.system.healthFail": "Gagal memuat health",
      "admin.system.configUpdated": "Konfigurasi diperbarui",
      "admin.system.configFail": "Gagal memperbarui",
      "admin.system.dbStats": "Statistik Database",
      "admin.system.maintenanceMsg": "Pesan Maintenance",
      "admin.system.maintenanceMsgPlaceholder":
        "Sistem sedang dalam pemeliharaan. Silakan coba lagi nanti.",
      "admin.system.maintenanceMsgDesc":
        "Pesan ini ditampilkan ke user saat maintenance mode aktif.",
      "admin.system.maintenanceMsgSaved": "Pesan maintenance disimpan",
      "admin.system.annualBilling": "Annual Billing Switch",
      "admin.system.annualBillingDesc":
        "Aktifkan pilihan Bulanan/Tahunan di halaman Pricing.",
      "admin.system.annualDiscount": "Konfigurasi Diskon Tahunan",
      "admin.system.annualDiscountDesc":
        "Saat annual billing ON, atur diskon menggunakan persentase atau nominal IDR.",
      "admin.system.discountType": "Jenis Diskon",
      "admin.system.discountPercent": "Persentase (%)",
      "admin.system.discountNominal": "Nominal (IDR)",
      "admin.system.discountValue": "Nilai Diskon",
      "admin.system.discountPercentMax": "Maksimum {{max}}%",
      "admin.system.discountNominalMax": "Maksimum Rp {{max}}",
      "admin.system.discountPreviewLabel": "Preview Diskon",
      "admin.system.discountPreviewStarter":
        "Estimasi hemat paket Starter: Rp {{value}} / tahun",
      "admin.system.planDist": "Distribusi Paket",
      "admin.system.activeUsers": "User Aktif",
      "admin.system.last7days": "7 hari terakhir",
      "admin.packages.title": "Package Management",
      "admin.packages.subtitle":
        "Kelola akses media per paket untuk model monetisasi SaaS.",
      "admin.packages.mediaAccessTitle": "Akses Tipe Media per Paket",
      "admin.packages.mediaAccessDesc":
        "Atur apakah tiap paket boleh analisis gambar, video, atau audio.",
      "admin.packages.planSettingsTitle": "Pengaturan Paket",
      "admin.packages.planSettingsDesc":
        "Kelola harga, kuota, limit harian, upload max size, dan cooldown untuk paket utama.",
      "admin.packages.mainPlanPolicy":
        "Paket utama mendukung hingga 10 plan. Plan private tidak tampil di pricing publik.",
      "admin.packages.mainAdd": "Tambah Paket Utama",
      "admin.packages.mainCount": "{{count}} / {{max}} paket utama",
      "admin.packages.main.maxTen": "Maksimal {{max}} paket utama.",
      "admin.packages.matrixTitle": "Matriks Konfigurasi Paket",
      "admin.packages.matrixDesc":
        "Semua pengaturan paket dikelola dalam satu tabel agar entry lebih rapi dan nyaman.",
      "admin.packages.annualTitle": "Konfigurasi Billing Tahunan",
      "admin.packages.annualDesc":
        "Pindahkan switch Bulanan/Tahunan dan diskon tahunan ke halaman Packages.",
      "admin.packages.field.name": "Nama Paket",
      "admin.packages.field.status": "Status Paket",
      "admin.packages.field.price": "Harga Bulanan (IDR)",
      "admin.packages.field.monthlyLimit": "Kuota Bulanan (analisis)",
      "admin.packages.field.dailyLimit": "Limit Harian (analisis)",
      "admin.packages.field.fileLimit": "Upload Max Size (MB)",
      "admin.packages.field.cooldown": "Cooldown (detik)",
      "admin.packages.field.maxVideoDuration":
        "Maks durasi video (detik, 0 = tanpa batas)",
      "admin.packages.field.maxAudioDuration":
        "Maks durasi audio (detik, 0 = tanpa batas)",
      "admin.packages.visibilityPublic": "Tampil di Pricing",
      "admin.packages.featureTitle": "Fitur Paket (CRUD)",
      "admin.packages.featureDesc":
        "Atur fitur laporan, penyimpanan, topup kredit, dan support untuk tiap paket.",
      "admin.packages.feature.storageUpload":
        "Bisa upload file untuk dianalisis",
      "admin.packages.feature.graceDays":
        "Paket tetap aktif setelah berhenti langganan (hari)",
      "admin.packages.feature.supportSlaHours": "SLA email support (jam)",
      "admin.packages.ai.none": "Tidak ada",
      "admin.packages.ai.basic": "Basic",
      "admin.packages.ai.full": "Lengkap",
      "admin.packages.language.id": "ID",
      "admin.packages.language.en": "EN",
      "admin.packages.state.enabled": "Aktif",
      "admin.packages.state.disabled": "Nonaktif",
      "admin.packages.state.public": "Public",
      "admin.packages.state.private": "Private",
      "admin.packages.state.popular": "Popular",
      "admin.packages.state.mostUsed": "Paling dipilih",
      "admin.packages.state.notMostUsed": "Bukan paling dipilih",
      "admin.packages.creditTitle": "CRUD Paket Kredit Tambahan",
      "admin.packages.creditDesc":
        "Tambah, ubah, atau hapus paket kredit tambahan (maksimal 10 paket).",
      "admin.packages.creditAdd": "Tambah Paket Kredit",
      "admin.packages.creditCount": "{{count}} / 10 paket",
      "admin.packages.creditLabel": "Label",
      "admin.packages.creditCredits": "Kredit",
      "admin.packages.creditPrice": "Harga (IDR)",
      "admin.packages.creditAction": "Aksi",
      "admin.packages.creditEmpty": "Belum ada paket kredit.",
      "admin.packages.credit.maxTen": "Maksimal 10 paket kredit.",
      "admin.packages.loadFail": "Gagal memuat konfigurasi paket.",
      "admin.packages.saved": "Konfigurasi paket berhasil disimpan.",
      "admin.packages.saveFail": "Gagal menyimpan konfigurasi paket.",

      // ── Admin Audit Log ────────────────────────────────────────────────────
      "admin.audit.title": "Audit Log",
      "admin.audit.subtitle":
        "Catatan semua aktivitas admin dengan auto-delete TTL.",
      "admin.audit.search": "Cari",
      "admin.audit.searchPlaceholder": "Cari email admin atau target...",
      "admin.audit.action": "Aksi",
      "admin.audit.allActions": "Semua Aksi",
      "admin.audit.dateFrom": "Dari",
      "admin.audit.dateTo": "Sampai",
      "admin.audit.refresh": "Refresh",
      "admin.audit.showing": "Menampilkan {{count}} dari {{total}} log",
      "admin.audit.ttlNote": "Log otomatis dihapus setelah 1 tahun",
      "admin.audit.noLogs": "Belum ada aktivitas yang tercatat.",
      "admin.audit.colTime": "Waktu",
      "admin.audit.colAdmin": "Admin",
      "admin.audit.colAction": "Aksi",
      "admin.audit.colTarget": "Target",
      "admin.audit.colDetails": "Detail",
      "admin.audit.colIP": "IP",
      "admin.audit.page": "Halaman {{page}} dari {{pages}}",
      "admin.audit.fetchError": "Gagal memuat audit log",

      // ── Admin Users Page ───────────────────────────────────────────────────
      "admin.usersPage.title": "Users",
      "admin.usersPage.count": "{{count}} users",
      "admin.usersPage.countFiltered": "{{filtered}} dari {{total}} users",
      "admin.usersPage.createUser": "Buat User",
      "admin.usersPage.searchPlaceholder": "Cari nama atau email...",
      "admin.usersPage.allPlans": "Semua Plan",
      "admin.usersPage.allRoles": "Semua Role",
      "admin.usersPage.thUser": "User",
      "admin.usersPage.thRole": "Role",
      "admin.usersPage.thPlan": "Plan",
      "admin.usersPage.thUsage": "Usage",
      "admin.usersPage.thJoined": "Bergabung",
      "admin.usersPage.thActions": "Aksi",
      "admin.usersPage.noMatch": "Tidak ada user yang cocok",
      "admin.usersPage.noUsers": "Tidak ada user",
      "admin.usersPage.deleteConfirm":
        "Hapus user {{email}}? Semua data user ini akan dihapus permanen.",
      "admin.usersPage.deleteSuccess": "User dihapus",
      "admin.usersPage.deleteFail": "Gagal menghapus user",
      "admin.usersPage.loadFail": "Gagal memuat users",
      "admin.usersPage.updated": "Diperbarui",
      "admin.usersPage.updateFail": "Gagal memperbarui",
      "admin.usersPage.modalCreate": "Buat User Baru",
      "admin.usersPage.modalEdit": "Edit User",
      "admin.usersPage.modalView": "Detail User",
      "admin.usersPage.lblName": "Nama",
      "admin.usersPage.lblEmail": "Email",
      "admin.usersPage.lblPassword": "Password",
      "admin.usersPage.lblPlan": "Plan",
      "admin.usersPage.lblRole": "Role",
      "admin.usersPage.lblUsageCount": "Usage Count",
      "admin.usersPage.phName": "Nama lengkap",
      "admin.usersPage.phEmail": "email@example.com",
      "admin.usersPage.phPassword": "Min. 8 karakter",
      "admin.usersPage.cancel": "Batal",
      "admin.usersPage.save": "Simpan",
      "admin.usersPage.create": "Buat User",
      "admin.usersPage.saveFail": "Gagal menyimpan",
      "admin.usersPage.createSuccess": "User berhasil dibuat!",
      "admin.usersPage.updateSuccess": "User diperbarui!",
      "admin.usersPage.loadDetailFail": "Gagal memuat data user",
      "admin.usersPage.requiredFields": "Nama, email, dan password wajib diisi",
      "admin.usersPage.analyses": "Analisis",
      "admin.usersPage.usage": "Pemakaian",
      "admin.usersPage.credits": "Kredit",
      "admin.usersPage.authType": "Tipe Auth",
      "admin.usersPage.joined": "Bergabung",
      "admin.usersPage.usageReset": "Reset Pemakaian",
      "admin.usersPage.recentAnalyses": "Analisis Terakhir",
      "admin.usersPage.recentTx": "Transaksi Terakhir",

      // ── Admin Analyses Page ────────────────────────────────────────────────
      "admin.analysesPage.title": "Analyses",
      "admin.analysesPage.totalDesc":
        "{{total}} total hasil analisis di platform.",
      "admin.analysesPage.all": "Semua",
      "admin.analysesPage.searchPlaceholder": "Cari media atau user...",
      "admin.analysesPage.search": "Cari",
      "admin.analysesPage.reset": "Reset",
      "admin.analysesPage.thVideo": "Media",
      "admin.analysesPage.thUser": "User",
      "admin.analysesPage.thVerdict": "Verdict",
      "admin.analysesPage.thConf": "Conf.",
      "admin.analysesPage.thType": "Tipe",
      "admin.analysesPage.thViews": "Views",
      "admin.analysesPage.thDate": "Tanggal",
      "admin.analysesPage.loading": "Memuat...",
      "admin.analysesPage.noDataFilter": "Tidak ada data dengan filter ini",
      "admin.analysesPage.noData": "Tidak ada data",

      // ── Admin Transactions Page ────────────────────────────────────────────
      "admin.txPage.title": "Transactions",
      "admin.txPage.totalDesc": "{{total}} total transaksi.",
      "admin.txPage.totalRevenue": "Total Revenue",
      "admin.txPage.searchPlaceholder": "Cari nama atau email user...",
      "admin.txPage.search": "Cari",
      "admin.txPage.allTypes": "Semua Tipe",
      "admin.txPage.allStatus": "Semua Status",
      "admin.txPage.allPlans": "Semua Plan",
      "admin.txPage.reset": "Reset",
      "admin.txPage.thUser": "User",
      "admin.txPage.thType": "Tipe",
      "admin.txPage.thPlanCredits": "Plan / Kredit",
      "admin.txPage.thAmount": "Jumlah",
      "admin.txPage.thStatus": "Status",
      "admin.txPage.thDate": "Tanggal",
      "admin.txPage.loading": "Memuat...",
      "admin.txPage.noDataFilter": "Tidak ada transaksi dengan filter ini",
      "admin.txPage.noData": "Belum ada transaksi",
      "admin.txPage.credits": "kredit",
      "admin.reports.tag": "Moderasi Konten",
      "admin.reports.title": "Flag Reports",
      "admin.reports.subtitlePrefix": "Laporan dari pengguna —",
      "admin.reports.subtitleSuffix": "total",
      "admin.reports.refresh": "Refresh",
      "admin.reports.filter.label": "Filter:",
      "admin.reports.filter.allStatus": "Semua Status",
      "admin.reports.filter.allReasons": "Semua Alasan",
      "admin.reports.filter.reset": "Reset",
      "admin.reports.filter.clear": "Hapus Filter",
      "admin.reports.filter.active": "filter aktif",
      "admin.reports.status.pending": "Pending",
      "admin.reports.status.reviewed": "Reviewed",
      "admin.reports.status.dismissed": "Dismissed",
      "admin.reports.bulk.selected": "{{count}} dipilih",
      "admin.reports.bulk.markReviewed": "Tandai Ditinjau",
      "admin.reports.bulk.dismiss": "Abaikan",
      "admin.reports.empty.default": "Tidak ada laporan.",
      "admin.reports.empty.withStatus":
        'Tidak ada laporan dengan status "{{status}}".',
      "admin.reports.table.analysis": "Analisis",
      "admin.reports.table.reason": "Alasan",
      "admin.reports.table.details": "Detail",
      "admin.reports.table.reportedAt": "Dilaporkan",
      "admin.reports.table.type": "Tipe",
      "admin.reports.table.status": "Status",
      "admin.reports.table.actions": "Aksi",
      "admin.reports.action.markReviewed": "Tandai Sudah Ditinjau",
      "admin.reports.action.dismiss": "Abaikan Laporan",
      "admin.reports.action.delete": "Hapus Laporan",
      "admin.reports.pagination.page": "Hal.",
      "admin.reports.pagination.reports": "laporan",
      "admin.reports.deleteConfirm.title": "Hapus Laporan?",
      "admin.reports.deleteConfirm.single":
        "Laporan ini akan dihapus permanen.",
      "admin.reports.deleteConfirm.multiple":
        "{{count}} laporan akan dihapus permanen.",
      "admin.reports.toast.loadError": "Gagal memuat laporan konten.",
      "admin.reports.toast.markedReviewed": "Ditandai sudah ditinjau.",
      "admin.reports.toast.dismissed": "Laporan diabaikan.",
      "admin.reports.toast.updateStatusError": "Gagal memperbarui status.",
      "admin.reports.toast.deleted": "Laporan dihapus.",
      "admin.reports.toast.deleteError": "Gagal menghapus laporan.",
      "admin.reports.toast.bulkDeleted": "{{count}} laporan dihapus.",
      "admin.reports.toast.bulkUpdated": "{{count}} laporan diperbarui.",
      "admin.reports.toast.bulkError": "Gagal menjalankan aksi massal.",

      // ── Notifications ─────────────────────────────────────────────────────
      "notify.loggedOut": "Anda telah keluar. Sampai jumpa!",
      "notify.permission.title": "Aktifkan Notifikasi",
      "notify.permission.desc":
        "Dapatkan pemberitahuan langsung untuk analisis selesai, kuota hampir habis, dan konfirmasi transaksi.",
      "notify.permission.allow": "Aktifkan",
      "notify.permission.later": "Nanti",

      // ── User Analytics ─────────────────────────────────────────────────────
      "analytics.title": "Analytics",
      "analytics.subtitle":
        "Statistik penggunaan dan tren analisis media Anda.",
      "analytics.totalAnalyses": "Total Analisis",
      "analytics.avgConfidence": "Rata-rata Kepercayaan",
      "analytics.thisWeek": "Minggu Ini",
      "analytics.lastWeek": "Minggu lalu",
      "analytics.quota": "Kuota",
      "analytics.credits": "kredit",
      "analytics.weeklyTrend": "Tren Mingguan (8 Minggu)",
      "analytics.analyses": "Analisis",
      "analytics.confidence": "Confidence",
      "analytics.noData": "Belum ada data. Mulai analisis pertama Anda!",
      "analytics.verdictDist": "Distribusi Verdict",
      "analytics.usageProgress": "Penggunaan Kuota",
      "analytics.monthlyUsage": "Kuota Bulanan",
      "analytics.creditsBalance": "Saldo Kredit",
      "analytics.upgradePlan": "Upgrade paket",
      "analytics.recentAnalyses": "Analisis Terbaru",
      "analytics.noAnalyses": "Belum ada analisis",
      "analytics.viewAll": "Lihat semua riwayat",
      "analytics.confByVerdict": "Confidence per Verdict",
      "analytics.mediaType": "Tipe Media",
      "admin.stats.users": "Total Pengguna",
      "admin.stats.analyses": "Total Analisis",
      "admin.stats.revenue": "Estimasi Revenue",
      "admin.stats.today": "Analisis Hari Ini",
      "admin.users.title": "Daftar Pengguna",
      "admin.users.search": "Cari pengguna...",
      "admin.users.name": "Nama",
      "admin.users.email": "Email",
      "admin.users.plan": "Paket",
      "admin.users.usage": "Pemakaian",
      "admin.users.joined": "Bergabung",
      "admin.users.actions": "Aksi",
      "admin.users.promote": "Jadikan Admin",
      "admin.users.delete": "Hapus",
      "admin.users.changePlan": "Ubah Paket",

      // ── Common ────────────────────────────────────────────────────────────
      "common.loading": "Memuat...",
      "common.error": "Terjadi kesalahan",
      "common.save": "Simpan",
      "common.cancel": "Batal",
      "common.confirm": "Konfirmasi",
      "common.close": "Tutup",

      // ── Footer ────────────────────────────────────────────────────────────
      "footer.tagline": "Verifikasi media di era konten digital.",
      "footer.product": "Produk",
      "footer.company": "Perusahaan",
      "footer.legal": "Legal",
      "footer.about": "Tentang Kami",
      "footer.contact": "Kontak",
      "footer.terms": "Syarat & Ketentuan",
      "footer.privacy": "Kebijakan Privasi",
      "footer.apiDocs": "API Docs",
      "footer.rights": "Kebenaran di Setiap Frame",
      "footer.madeIn": "Hadir dengan ❤️ di Indonesia",

      // ── Verification Banner ───────────────────────────────────────────────
      "verify.banner.text": "Email belum diverifikasi. Cek inbox",
      "verify.banner.link": "untuk link verifikasi.",
      "verify.banner.resend": "Kirim Ulang",
      "verify.banner.sending": "Mengirim...",
      "verify.banner.sent":
        "Email verifikasi telah dikirim ulang. Cek inbox Anda.",
      "verify.banner.tooMany":
        "Terlalu banyak permintaan. Coba lagi dalam 15 menit.",
      "verify.banner.failed": "Gagal mengirim email verifikasi.",

      // ── Resend Verification ───────────────────────────────────────────────
      "resend.back": "Kembali",
      "resend.sent.title": "Email Terkirim",
      "resend.sent.desc": "Link verifikasi telah dikirim ke:",
      "resend.sent.note":
        "Silakan cek email Anda dan klik link verifikasi. Link berlaku selama 15 menit.",
      "resend.sent.redirecting": "Mengalihkan ke beranda...",
      "resend.title": "Kirim Ulang Verifikasi",
      "resend.subtitle":
        "Email belum diverifikasi? Kami akan mengirimkan link verifikasi ke email Anda.",
      "resend.email.label": "Alamat Email",
      "resend.submit": "Kirim Link Verifikasi",
      "resend.submitting": "Mengirim...",
      "resend.error.tooMany":
        "Terlalu banyak permintaan. Coba lagi dalam 15 menit.",
      "resend.error.failed": "Gagal mengirim email verifikasi.",
      "resend.error.generic": "Terjadi kesalahan. Silakan coba lagi.",
      "resend.success":
        "Email verifikasi telah dikirim. Silakan cek inbox Anda.",
      "resend.haveAccount": "Ingat password Anda?",
      "resend.signIn": "Masuk sekarang",
      "resend.noAccount": "Belum punya akun?",
      "resend.register": "Daftar di sini",
      "emailVerification.loading.title": "Memverifikasi Email",
      "emailVerification.loading.subtitle": "Silakan tunggu sebentar...",
      "emailVerification.success.title": "✓ Email Terverifikasi!",
      "emailVerification.success.desc":
        "Akun Anda berhasil diaktifkan. Selamat datang di Veriksa!",
      "emailVerification.success.redirecting":
        "Mengalihkan ke halaman login...",
      "emailVerification.error.title": "Verifikasi Gagal",
      "emailVerification.error.missingToken":
        "Token verifikasi tidak ditemukan",
      "emailVerification.error.verifyFailed": "Gagal memverifikasi email",
      "emailVerification.error.resendTitle": "Link Verifikasi Alami Masalah?",
      "emailVerification.error.resendDesc":
        "Anda dapat meminta link verifikasi baru dari halaman verifikasi email.",
      "emailVerification.error.resendBtn": "Minta Link Baru →",
      "emailVerification.error.backToLogin": "Kembali ke Login",
      "emailVerification.error.backToRegister": "Daftar Ulang",
      "emailVerification.help.prefix": "Pertanyaan?",
      "emailVerification.help.link": "Hubungi support",
    },
  },
  en: {
    translation: {
      // ── Common ────────────────────────────────────────────────────────────
      "common.save": "Save",
      "common.cancel": "Cancel",
      "common.loading": "Loading...",
      "common.error": "An error occurred",
      "common.back": "Back",
      "common.or": "or",
      "common.required": "Required",
      "common.submit": "Submit",
      "common.delete": "Delete",
      "common.edit": "Edit",
      "common.close": "Close",
      "common.retry": "Try Again",
      "common.copied": "Copied!",

      // ── Nav ────────────────────────────────────────────────────────────────
      "nav.analyze": "Analyze",
      "nav.discover": "Discover",
      "nav.videos": "Videos",
      "nav.history": "History",
      "nav.account": "Account",
      "nav.analytics": "Analytics",
      "nav.dashboard": "Dashboard",
      "nav.admin": "Admin",
      "nav.pricing": "Pricing",
      "nav.signIn": "Sign In",
      "nav.getStarted": "Get Started",
      "nav.newAnalysis": "New Analysis",
      "nav.subscription": "Subscription",
      "nav.paymentHistory": "Payment History",
      "nav.editProfile": "Edit Profile",
      "nav.signOut": "Sign Out",

      // ── Home ───────────────────────────────────────────────────────────────
      "home.badge": "AI-Powered Digital Media Forensics Platform",
      "home.hero1": "Detect Deepfakes and Media Manipulation",
      "home.hero2": "in Seconds.",
      "home.analysisEngine": "Risk Analysis Engine",
      "home.heroTitle": "Media Risk Analysis",
      "home.heroDesc":
        "Veriksa analyzes video, audio, and images to identify deepfakes, AI manipulation, and synthetic content. Get a forensic risk analysis report in seconds, right in your browser.",
      "home.cta.analyze": "Start Free Analysis",
      "home.cta.demo": "See How It Works",
      "home.trusted":
        "Trusted by journalists & media researchers across Indonesia",
      "home.stats.analyzed": "Completed Analyses",
      "home.stats.accuracy": "Detection Accuracy",
      "home.stats.time": "Average Time",
      "home.stats.highRisk": "High Risk Detected",
      "home.stats.lowRisk": "Low Risk",
      "home.howItWorks": "How Veriksa Works",
      "home.howItWorksNav": "How It Works",
      "home.step1.title": "Upload or Paste URL",
      "home.step1.desc":
        "Upload a video file directly or paste a URL from YouTube, Twitter/X, TikTok, and other platforms.",
      "home.step2.title": "AI Forensic Analysis",
      "home.step2.desc":
        "Our AI models analyze deepfake artifacts, temporal consistency, and manipulation patterns in depth.",
      "home.step3.title": "Instant Detailed Report",
      "home.step3.desc":
        "Get a detailed forensic report with confidence score, detected artifacts, and actionable recommendations.",
      "home.features.title": "Enterprise-Grade Detection. Accessible Pricing.",
      "home.features.eyebrow": "Capabilities",
      "home.features.advanced.title": "AI Risk Signal Detection",
      "home.features.advanced.desc":
        "Detects AI manipulation from visual artifacts, temporal inconsistencies, and statistical patterns — all in one unified report.",
      "home.features.url.title": "Analyze Any URL Instantly",
      "home.features.url.desc":
        "Paste a URL from YouTube, Twitter/X, TikTok, or any platform — no manual downloading required.",
      "home.features.fast.title": "Results in Seconds",
      "home.features.fast.desc":
        "Full risk assessment report in 30–120 seconds, depending on media length and complexity.",
      "home.features.secure.title": "Privacy Guaranteed",
      "home.features.secure.desc":
        "Your media is processed securely and deleted automatically after analysis. Nothing is stored permanently.",
      "home.useCases.eyebrow": "Who It's For",
      "home.useCases.title": "Built for Teams That Need Fast Verification",
      "home.useCases.desc":
        "Veriksa supports multiple workflows: newsroom, communications, research, and compliance teams.",
      "home.useCases.journalist.title": "Journalists & Editors",
      "home.useCases.journalist.desc":
        "Validate media before publishing to reduce misinformation risk.",
      "home.useCases.comms.title": "Communications Teams",
      "home.useCases.comms.desc":
        "Quickly verify viral content before issuing official statements.",
      "home.useCases.research.title": "Researchers & Academics",
      "home.useCases.research.desc":
        "Get structured risk signals for observation and digital-content studies.",
      "home.useCases.enterprise.title": "Compliance & Brand",
      "home.useCases.enterprise.desc":
        "Monitor potential impersonation and manipulated content targeting brand reputation.",
      "home.pricing.title": "Transparent Pricing, No Surprises",
      "home.pricing.desc": "Start free. Upgrade when you're ready.",
      "home.cta.title": "Don't Just Trust It. Verify It.",
      "home.cta.desc":
        "Start free — no credit card, no commitment. Your first analysis takes just seconds.",
      "home.cta.start": "Start Now — Free",
      "home.footer.tagline": "Automated Media Risk Assessment",
      "home.footer.rights": "All rights reserved.",

      // ── Login ──────────────────────────────────────────────────────────────
      "login.leftBadge": "Media Risk Analysis",
      "login.leftTitle": "Verify Media.\nProtect Trust.",
      "login.leftDesc":
        "AI-powered forensic detection for journalists, researchers, and content creators who need to know the truth.",
      "login.leftF1": "Dual-layer AI deepfake detection",
      "login.leftF2": "AI-powered frame-by-frame analysis",
      "login.leftF3": "Complete forensic reports with confidence scores",
      "login.title": "Sign In",
      "login.subtitle": "Don't have an account?",
      "login.signupLink": "Sign up free",
      "login.email": "Email",
      "login.password": "Password",
      "login.forgot": "Forgot password?",
      "login.forgotPassword": "Forgot password?",
      "login.submit": "Sign In",
      "login.google": "Continue with Google",
      "login.divider": "or sign in with email",
      "login.success": "Signed in successfully! Welcome back.",
      "login.error.invalid": "Incorrect email or password. Please try again.",
      "login.failed": "Sign-in failed. Please check your credentials.",
      "login.otpSent": "OTP code sent to your email",
      "login.otpTitle": "OTP Verification",
      "login.otpDesc": "Code sent to",
      "login.otpDigits": "Enter 6-digit OTP code",
      "login.otpInvalid": "Invalid OTP",
      "login.otpSubmit": "Verify & Sign In",
      "login.otpVerifying": "Verifying...",
      "login.otpResendBtn": "Resend OTP",
      "login.otpResending": "Sending...",
      "login.otpResent": "New OTP sent!",
      "login.otpResendFail": "Failed to resend OTP",
      "login.backToLogin": "Back to sign in",
      "login.welcomeBack": "Welcome back, {{name}}!",
      "login.heroTag": "Media Risk Analysis",
      "login.heroTitle": "Verify Digital\nMedia with AI",
      "login.heroDesc":
        "Trusted AI platform to detect deepfakes and manipulated media — accurate, fast, and easy to use.",
      "login.feature1": "Enterprise-grade AI deepfake detection",
      "login.feature2": "Accurate analysis with confidence scores",
      "login.feature3": "File upload & social media URL support",

      // ── Register ───────────────────────────────────────────────────────────
      "register.title": "Create Free Account",
      "register.subtitle": "Already have an account?",
      "register.signinLink": "Sign in",
      "register.name": "Full Name",
      "register.email": "Email",
      "register.password": "Password",
      "register.passwordHint": "Minimum 8 characters",
      "register.password_confirm": "Confirm Password",
      "register.password_mismatch": "Passwords do not match",
      "register.submit": "Create Account",
      "register.google": "Sign up with Google",
      "register.divider": "or sign up with email",
      "register.success": "Account created! Welcome to Veriksa 🎉",
      "register.terms_prefix": "I have read and agree with",
      "register.terms": "Terms of Service",
      "register.and": "and",
      "register.privacy": "Privacy Policy",
      "register.terms_error":
        "You must agree to the Terms of Service and Privacy Policy to continue",
      "register.newsletter":
        "I'd like to receive newsletters and important updates from Veriksa",
      "register.product_updates":
        "I'd like to receive product updates and announcements from Veriksa",
      "register.terms_notice_prefix":
        "By creating an account, you agree to our",
      "register.and_privacy": "and",
      "register.terms_notice_suffix":
        "We'll send you account-related emails based on your preferences above.",
      "register.verify.emailSent": "Verification email has been sent",
      "register.error.tooMany": "Too many requests. Try again in 15 minutes.",
      "register.error.registerFailed": "Registration failed",
      "register.error.resendFailed": "Failed to resend verification email",
      "register.step2.title": "Check Your Email",
      "register.step2.subtitle": "We have sent a verification link to",
      "register.step2.nextStepsTitle": "Next steps:",
      "register.step2.next1": "Open the email you just received",
      "register.step2.next2": 'Click the "Verify Email" button',
      "register.step2.next3": "Your account will be activated instantly",
      "register.step2.notePrefix": "Verification link valid for",
      "register.step2.noteDuration": "15 minutes",
      "register.step2.resendPrompt": "Did not receive the email?",
      "register.step2.backToForm": "Back to form",
      "register.step2.haveAccount": "Already have an account?",

      // ── Analyze ────────────────────────────────────────────────────────────
      "analyze.title": "Forensic Analysis",
      "analyze.waitNote":
        "Stay on this page while we analyze your media — typically done in 30–120 seconds.",
      "analyze.freePlanNotice":
        "You're on the free plan with a limited number of analysis credits.",
      "analyze.freePlanUpgrade": "Upgrade to a paid plan for a higher quota.",
      "analyze.subtitle":
        "Upload media or paste a URL — analysis results in seconds.",
      "analyze.tab.upload": "Upload File",
      "analyze.tab.url": "Video URL",
      "analyze.url.label": "Video URL",
      "analyze.url.placeholder":
        "https://youtube.com/watch?v=... or direct video URL",
      "analyze.url.hint":
        "Supports YouTube, Twitter/X, TikTok, and direct video URLs",
      "analyze.model.label": "AI Model",
      "analyze.btn.analyze": "Start Analysis",
      "analyze.btn.analyzing": "Analyzing...",
      "analyze.btn.selectFile": "Select a file to continue",
      "analyze.btn.enterUrl": "Enter a URL to continue",
      "analyze.error.noFile": "Please select a media file first",
      "analyze.error.noUrl": "Please enter a media URL first",
      "analyze.error.quotaMonthly":
        "Monthly quota exceeded. Please upgrade your plan.",
      "analyze.error.quotaDaily": "Daily limit reached. Try again tomorrow.",
      "analyze.stage0": "Initializing forensic scanner...",
      "analyze.stage1": "Processing video frames...",
      "analyze.stage2": "Running deepfake detection model...",
      "analyze.stage3": "Analyzing temporal artifacts...",
      "analyze.stage4": "Examining lighting & shadow consistency...",
      "analyze.stage5": "Compiling risk assessment report...",
      "analyze.quota.monthly": "Monthly quota remaining",
      "analyze.quota.daily": "Daily quota remaining",

      // ── Results ────────────────────────────────────────────────────────────
      "results.title": "Analysis Report",
      "results.forensicReport": "Analysis Report",
      "results.verdictLabel": "Analysis Verdict",
      "results.verdict.REAL": "REAL",
      "results.verdict.FAKE": "FAKE",
      "results.verdict.SUSPICIOUS": "SUSPICIOUS",
      "results.verdict.UNCERTAIN": "UNCERTAIN",
      "results.confidence": "Confidence Score",
      "results.detectionCertainty": "Detection Certainty",
      "results.summary": "Summary",
      "results.artifacts": "Detected Artifacts",
      "results.technical": "Technical Breakdown",
      "results.model": "AI Model",
      "results.inputType": "Input Type",
      "results.aiEngine": "AI Engine",
      "results.date": "Analysis Date",
      "results.videoName": "Media Name",
      "results.contentInfo": "Media Content",
      "results.newAnalysis": "New Analysis",
      "results.share": "Share",
      "results.copyLink": "Copy Link",
      "results.linkCopied": "Link copied!",
      "results.makePublic": "Make Public",
      "results.makePrivate": "Make Private",
      "results.public": "Public",
      "results.private": "Private",
      "results.publicBadge": "This result is visible to the public",
      "results.privateBadge": "Only you can see this result",
      "results.downloadPdf": "Download PDF",
      "results.facial": "Facial Analysis",
      "results.temporal": "Temporal Consistency",
      "results.lighting": "Lighting & Shadows",
      "results.audio": "Audio Analysis",
      "results.audioVisualSync": "Audio-Visual Sync",
      "results.metadata": "Metadata Analysis",
      "results.background": "Background Analysis",
      "results.overallQuality": "Overall Quality",
      "results.rawResponse": "Raw AI Response",
      "results.publicShared": "This report is publicly accessible by anyone",
      "results.signupCta": "Sign up free — analyze your own media now",
      "results.notFound": "Report could not be accessed",
      "results.notFoundTitle": "Report Unavailable",
      "results.notFoundDesc":
        "This report is private, has been deleted, or could not be found.",
      "results.meta": "Meta",
      "results.upload": "File Upload",
      "results.langMismatch":
        "This analysis was performed in a different language",
      "results.hiveTitle": "HIVE AI DETECTION",
      "results.hiveAiGenerated": "AI-Generated",
      "results.hiveDeepfake": "Deepfake",
      "results.hiveAiAudio": "AI Audio",
      "results.hiveFrames": "Frames",
      "results.hiveGenerator": "Detected Source",
      "results.detectionTitle": "AI DETECTION",
      "results.scoreReal": "Real",
      "results.scoreAiGenerated": "AI-Generated",
      "results.scoreDeepfake": "Deepfake",
      "results.scoreAiAudio": "AI Audio",
      "results.generationSources": "Generation Sources",
      "results.noGenerationSources": "No AI generators detected",
      "results.generationSourcesTooltip":
        "These sources indicate AI models that were likely used to create this content.",
      "results.seeMore": "See all sources",
      "results.seeLess": "See less",
      "results.pdfGenerating": "Generating PDF...",
      "results.pdfSuccess": "PDF downloaded!",
      "results.pdfError": "Failed to generate PDF",
      "results.archiveBtn": "Delete This Report",
      "results.archiveConfirm":
        "Remove from history? The analysis remains stored in admin.",
      "results.archiveSuccess": "Analysis removed from history.",
      "results.makePublicFirst":
        "Enable public visibility before sharing the link.",
      "results.shareIdMissing": "Share ID not available",
      "results.shareTextFake":
        "This media was flagged as HIGH RISK with {{confidence}}% confidence — analyzed by Veriksa AI!",
      "results.shareTextOther":
        "Risk assessment complete: {{verdict}} ({{confidence}}%) — see the full report on Veriksa AI!",
      "results.privacyToggleOwner":
        "This is your report — toggle visibility below",

      // ── Risk Level ───────────────────────────────────────────────────────
      "results.riskLevel": "Risk Level",
      "results.riskHigh": "High Risk",
      "results.riskMedium": "Medium Risk",
      "results.riskLow": "Low Risk",
      "results.riskUncertain": "Uncertain",
      "results.riskHighDesc":
        "Strong indicators that this content is AI-generated or a deepfake.",
      "results.riskMediumDesc":
        "Some manipulation indicators are present, but the evidence is inconclusive.",
      "results.riskLowDesc":
        "Strong indicators that this content is authentic and unmanipulated.",
      "results.riskUncertainDesc":
        "Insufficient data available to determine the risk level with confidence.",

      // ── Display Verdict Labels (risk-based, shown in UI) ──────────────────
      "results.displayFake": "HIGH RISK",
      "results.displayReal": "LOW RISK",
      "results.displayUncertain": "UNCERTAIN",
      "results.displayInsufficient": "INSUFFICIENT SIGNAL",
      "results.verdictDisclaimer":
        "This is an automated, informational risk assessment — not a definitive forensic conclusion.",
      "results.downloadBadge": "Download Badge",

      // ── Recommendations ──────────────────────────────────────────────────
      "results.recommendations": "Recommendations",
      "results.noRecommendations": "No recommendations available.",
      "results.feedbackTitle": "Result Feedback",
      "results.feedbackQuestion": "Is this analysis result accurate?",
      "results.feedbackCorrect": "Yes, accurate",
      "results.feedbackIncorrect": "Needs correction",
      "results.feedbackHint":
        "Your feedback helps improve the detection model quality.",
      "results.feedbackSaved": "Feedback saved successfully.",
      "results.feedbackError": "Failed to save feedback.",
      "results.feedbackCurrent": "Your feedback: {{value}}",
      "results.feedbackValue.correct": "Accurate",
      "results.feedbackValue.incorrect": "Needs correction",

      // ── About ─────────────────────────────────────────────────────────────
      "about.tag": "Company",
      "about.title": "About Veriksa",
      "about.desc":
        "Veriksa is an AI-powered deepfake detection platform built for the Indonesian context. We help journalists, researchers, content creators, and the public verify media in an era of increasingly sophisticated synthetic content.",
      "about.mission.title": "Our Mission",
      "about.mission.desc":
        "Helping Indonesian society distinguish authentic content from deepfakes and manipulated media — quickly, accurately, and accessibly.",
      "about.tech.title": "Technology",
      "about.tech.desc":
        "Powered by two AI layers: one for technical signal detection, one for deep narrative analysis — both working in perfect complement for the best possible results.",
      "about.contact.title": "Contact",
      "about.contact.desc": "Inquiries & partnerships: hello@veriksa.id",
      "about.why.title": "Why Veriksa?",
      "about.why.f1":
        "Analysis completed in minutes using enterprise-grade AI models",
      "about.why.f2":
        "Supports file upload and URL analysis (YouTube, TikTok, Instagram, and more)",
      "about.why.f3": "Full forensic report: face, temporal, lighting, audio",
      "about.why.f4": "Affordable IDR pricing, free plan available forever",
      "about.why.f5": "Data is never stored permanently — privacy guaranteed",
      "about.api.title": "API Access",
      "about.api.desc":
        "API access is available for Business plan users. API documentation coming soon.",
      "about.contactUs.title": "Contact Us",
      "about.contactUs.email": "Email: hello@veriksa.id",
      "about.contactUs.security":
        "For security vulnerability reports: security@veriksa.id",
      "about.links.pricing": "View Pricing →",
      "about.links.terms": "Terms & Conditions",
      "about.links.privacy": "Privacy Policy",

      "videos.archive": "Analysis Archive",
      "videos.title": "Media",

      // ── Discover (Public Analysis Feed) ──────────────────────────────────────
      "discover.archive": "Public Reports",
      "discover.title": "Discover",
      "discover.untitled": "Untitled",
      "discover.reportBtn": "Report this content",
      "discover.reported": "Reported",
      "discover.reportSent": "Report submitted. Thank you.",
      "discover.flagReasonTitle": "Pick a reason",
      "discover.flagReason.misleading": "Verdict feels misleading",
      "discover.flagReason.inappropriate": "Content is inappropriate",
      "discover.flagReason.duplicate": "Duplicate report",
      "discover.flagReason.hoax": "Used to spread hoaxes",
      "discover.flagReason.other": "Other",
      "discover.flagDetailsPlaceholder": "Details (optional, max 200 chars)",
      "discover.flagSubmit": "Submit Report",
      "discover.searchPlaceholder": "Search title or description...",
      "discover.subtitle":
        "Analysis reports published by the Veriksa community. Total",
      "discover.public": "public reports.",
      "discover.analyzeBtn": "Analyze Your Media",
      "discover.empty.title": "No public reports yet",
      "discover.empty.text":
        "Be the first to analyze and share a result with the community!",
      "discover.empty.cta": "Start Free",
      "discover.card.view": "View",
      "discover.media.all": "All",
      "discover.media.video": "Video",
      "discover.media.image": "Image",
      "discover.media.audio": "Audio",
      "discover.dateRange": "Date Range",
      "discover.dateFrom": "From",
      "discover.dateTo": "To",
      "discover.applyFilter": "Apply",
      "discover.prev": "Previous",
      "discover.next": "Next",
      "discover.cta.title": "Spotted something suspicious?",
      "discover.cta.desc":
        "Analyze with Veriksa and share the results with the community. Free for your first 3 analyses.",
      "discover.cta.btn": "Start Free",
      "videos.subtitle": "Analysis results published by the Veriksa community.",
      "videos.public": "public reports",
      "videos.analyzeBtn": "Analyze Your Media",
      "videos.empty.title": "No public reports yet",
      "videos.empty.text":
        "Be the first to analyze and share a result with the community!",
      "videos.empty.cta": "Start Free",
      "videos.card.view": "View",
      "videos.sort.newest": "Newest",
      "videos.sort.trending": "Trending",
      "videos.sort.mostViews": "Most Views",
      "videos.sort.popular": "Popular",
      "videos.filter.all": "All",
      "videos.filter.deepfake": "Deepfake",
      "videos.filter.real": "Authentic",
      "videos.filter.uncertain": "Uncertain",
      "videos.prev": "Previous",
      "videos.next": "Next",
      "videos.userFallback": "Veriksa User",
      "videos.cta.title": "Have a suspicious video?",
      "videos.cta.desc":
        "Analyze with Veriksa and share the result with the community. Free for your first 3 videos.",
      "videos.cta.btn": "Start Free",
      "results.facial": "Facial Analysis",
      "results.temporal": "Temporal Consistency",
      "results.lighting": "Lighting & Shadows",
      "results.audio": "Audio Analysis",
      "results.audioVisualSync": "Audio-Visual Sync",
      "results.metadata": "Metadata Analysis",

      // ── Dashboard ──────────────────────────────────────────────────────────
      "dashboard.title": "Dashboard",
      "dashboard.welcome": "Welcome,",
      "dashboard.usage.title": "This Month's Usage",
      "dashboard.usage.remaining": "Remaining this month",
      "dashboard.usage.daily": "Daily limit",
      "dashboard.usage.fileLimit": "Max file size",
      "dashboard.usage.reset": "Quota reset",
      "dashboard.usage.analyses": "analyses",
      "dashboard.usage.perDay": "/day",
      "dashboard.plan.title": "Current Plan",
      "dashboard.plan.perMonth": "analyses/month",
      "dashboard.plan.unlimited": "Unlimited",
      "dashboard.plan.paymentHistory": "Payment history",
      "dashboard.plan.upgrade": "Upgrade Plan",
      "dashboard.plan.change": "Change Plan",
      "dashboard.plan.recurring": "Auto Subscription",
      "dashboard.plan.recurringActive": "Active — auto-renewed monthly",
      "dashboard.plan.recurringFailed":
        "Payment failed — update payment method",
      "dashboard.plan.recurringPending":
        "Pending activation — complete payment",
      "dashboard.plan.nextCharge": "Next charge",
      "dashboard.plan.label.free": "Free",
      "dashboard.plan.label.starter": "Starter",
      "dashboard.plan.label.pro": "Pro",
      "dashboard.plan.label.business": "Business",
      "dashboard.plan.label.unlimited": "Unlimited",
      "dashboard.plan.cancelSub": "Cancel Subscription",
      "dashboard.plan.cancelConfirm":
        "Are you sure you want to cancel? You'll retain premium access until the end of this period, then switch to Free.",
      "dashboard.plan.cancelSuccess":
        "Cancellation scheduled. Your plan will switch to Free at period end.",
      "dashboard.plan.trialActive": "Trial — {{days}} days left",
      "dashboard.plan.trialExpired": "Trial period has ended",
      "subscription.title": "Subscription",
      "subscription.subtitle":
        "Manage your active plan, upgrade, downgrade, and cancellation flow.",
      "subscription.currentPlan": "Current Plan",
      "subscription.resetAt": "Next quota reset: {{date}}",
      "subscription.pendingDowngrade":
        "Downgrade to {{plan}} is scheduled on {{date}}.",
      "subscription.managePlans": "Manage Plans",
      "subscription.howTo": "Upgrade / Downgrade Flow",
      "subscription.step.upgrade":
        "Upgrade from the Pricing page. Upgrade is applied immediately after successful payment.",
      "subscription.step.downgrade":
        "Downgrade is scheduled at the end of the active period to keep current access stable.",
      "subscription.step.cancel":
        "Cancel if needed. Your account will return to the Free plan based on current policy.",
      "subscription.loadFailed": "Failed to load subscription status.",
      "dashboard.refresh": "Refresh data",
      "dashboard.quickAction.title": "Start New Analysis",
      "dashboard.quickAction.desc":
        "Upload media or paste a URL for instant AI risk assessment.",
      "dashboard.quickAction.btn": "New Analysis",
      "dashboard.recent.title": "Recent Analyses",
      "dashboard.recent.seeAll": "See all",
      "dashboard.recent.empty": "No analyses yet.",
      "dashboard.recent.first": "Start your first analysis",
      "dashboard.recent.colThumbnail": "Thumbnail",
      "dashboard.recent.colContent": "Title & Excerpt",
      "dashboard.recent.colScore": "Risk Score",
      "dashboard.recent.colDate": "Analysis Date",
      "dashboard.recent.noExcerpt": "No summary available.",
      "dashboard.recent.untitled": "Untitled",
      "dashboard.warning.near": "You're almost out of quota",
      "dashboard.warning.nearDetail":
        "Quota is running low ({{used}}/{{limit}}).",
      "dashboard.warning.full": "This month's quota is full. Resets on",
      "dashboard.warning.fullDetail":
        "This month's quota is full. Resets on {{date}}.",
      "dashboard.warning.upgrade": "Upgrade now",
      "dashboard.warning.upgradeToContinue": "Upgrade to continue",
      "dashboard.verify.title": "Verifying payment...",
      "dashboard.verify.desc": "Please wait, updating your plan.",
      "dashboard.verify.failed.title": "Payment confirmed at Midtrans",
      "dashboard.verify.failed.desc":
        "The system is syncing your payment status. Please click verify again.",
      "dashboard.verify.btn": "Verify Again",
      "dashboard.payment.success":
        "Payment successful! Your plan has been upgraded.",
      "dashboard.payment.pending": "Payment is pending completion.",
      "dashboard.payment.failed": "Payment failed or expired.",
      "dashboard.payment.trialActive": "Plan activated.",
      "dashboard.credits.title": "Analysis Credits",
      "dashboard.credits.balance": "Credits Balance",
      "dashboard.credits.buy": "Buy Credits",
      "dashboard.credits.expires": "Valid until",
      "dashboard.credits.empty": "No active credits",
      "dashboard.credits.unit": "credits",
      "dashboard.credits.success": "Credits added successfully!",
      "dashboard.credits.pending": "Waiting for credit payment...",
      "dashboard.credits.failed": "Credit payment failed.",

      // ── Pricing ────────────────────────────────────────────────────────────
      "pricing.badge": "Pricing",
      "pricing.title": "Choose the Veriksa Plan That Fits Your Needs",
      "pricing.subtitle":
        "Start with Free, then upgrade when your analysis volume grows.",
      "pricing.popular": "Most Popular",
      "pricing.current": "Active",
      "pricing.perMonth": "/month",
      "pricing.free": "Free",
      "pricing.plan.free": "Free",
      "pricing.plan.starter": "Starter",
      "pricing.plan.pro": "Pro",
      "pricing.plan.business": "Business",
      "pricing.unlimited": "Unlimited analyses",
      "pricing.analyses": "analyses/month",
      "pricing.cta.free": "Start Free",
      "pricing.trialBadge": "7 days free!",
      "pricing.trialActivated":
        "{{days}}-day trial activated! Enjoy premium features.",
      "pricing.loginRequired": "Please sign in to upgrade",
      "pricing.cta.upgrade": "Upgrade to",
      "pricing.cta.downgrade": "Downgrade to",
      "pricing.confirmDowngrade":
        "Are you sure you want to downgrade? The change will take effect at the end of your current billing period.",
      "pricing.downgradeScheduled":
        "Downgrade scheduled. Effective on {{effectiveDate}}.",
      "pricing.cta.current": "Current Plan",
      "pricing.processing": "Processing...",
      "pricing.compare.show": "View full feature comparison",
      "pricing.compare.hide": "Hide full feature comparison",
      "pricing.compare.link": "See full feature comparison",
      "pricing.compare.detailTitle": "Full Feature Comparison",
      "pricing.compare.detailSubtitle":
        "Compare plan capabilities side-by-side to pick what fits your needs.",
      "pricing.compare.col.feature": "Feature",
      "pricing.compare.row.monthlyLimit": "Analyses / month",
      "pricing.compare.row.dailyLimit": "Max analyses / day",
      "pricing.compare.row.fileLimit": "Upload max size",
      "pricing.compare.row.cooldown": "Cooldown",
      "pricing.compare.row.maxVideoDuration": "Max video duration",
      "pricing.compare.row.maxAudioDuration": "Max audio duration",
      "pricing.compare.row.gracePeriod": "Active access after cancellation",
      "pricing.compare.row.aiExplain": "AI explanation",
      "pricing.compare.row.reportLanguages": "Report languages",
      "pricing.compare.tooltip.ai.noneLabel": "None:",
      "pricing.compare.tooltip.ai.noneDesc": "no AI summary.",
      "pricing.compare.tooltip.ai.basicLabel": "Basic:",
      "pricing.compare.tooltip.ai.basicDesc": "concise summary.",
      "pricing.compare.tooltip.ai.fullLabel": "Full:",
      "pricing.compare.tooltip.ai.fullDesc":
        "summary plus deeper technical context.",
      "pricing.compare.tooltip.reportTechnical":
        "When enabled, the report includes additional technical breakdown (artifacts, indicators, and analysis context).",
      "pricing.compare.tooltip.label": "View explanation",
      "pricing.compare.row.emailSupport": "Email support",
      "pricing.compare.value.basic": "Basic",
      "pricing.compare.value.full": "Full",
      "pricing.compare.value.notAvailable": "Not available",
      "pricing.compare.value.seconds": "{{count}} sec",
      "pricing.compare.value.days": "{{count}} days",
      "pricing.compare.value.minutes": "{{value}} min",
      "pricing.compare.value.unlimited": "Unlimited",
      "pricing.lang.id": "ID",
      "pricing.lang.en": "EN",
      "pricing.billing.monthly": "Monthly",
      "pricing.billing.annual": "Annual",
      "pricing.billing.annualSave": "Save {{value}} / year",
      "pricing.billing.yearlyBilled": "Billed yearly",
      "pricing.billing.discountInfoPercent": "{{value}}% yearly discount",
      "pricing.billing.discountInfoNominal": "{{value}} yearly discount",
      "pricing.billing.discountOff": "Annual discount off",
      "pricing.loadPlansFailed": "Failed to load pricing plans.",
      "pricing.noPaidPlans":
        "There is no active public paid plan at the moment.",
      "pricing.paymentSuccess": "Payment successful!",
      "pricing.paymentPending": "Waiting for payment...",
      "pricing.paymentFailed": "Payment failed.",
      "pricing.checkoutFailed": "Failed to start checkout.",
      "pricing.snapUnavailable":
        "Midtrans Snap is not ready yet. Please try again.",
      "pricing.credit.pending": "Waiting for credit payment...",
      "pricing.credit.failed": "Credit payment failed.",
      "pricing.footer":
        "Payments processed securely by Midtrans · QRIS, GoPay, ShopeePay, Bank Transfer · Cancel anytime",
      "pricing.login.required": "Login required to upgrade",
      "pricing.redirect": "Redirecting to payment page...",
      "pricing.sec.quota": "Quota & Limits",
      "pricing.sec.detect": "Detection",
      "pricing.sec.report": "Reports",
      "pricing.sec.storage": "Storage",
      "pricing.sec.support": "Support",
      "pricing.feat.soon": "COMING SOON",
      "pricing.feat.quota.monthly": "{{count}} analyses / month",
      "pricing.feat.quota.daily": "Max. {{count}} analyses / day",
      "pricing.feat.quota.file": "Upload limit: {{size}}",
      "pricing.feat.quota.cooldown": "Cooldown {{seconds}} seconds",
      "pricing.feat.quota.maxVideoDuration": "Video duration: {{value}}",
      "pricing.feat.quota.maxAudioDuration": "Audio duration: {{value}}",
      "pricing.feat.detect.all": "Image, video & audio",
      "pricing.feat.detect.image": "Image / Photo",
      "pricing.feat.detect.video": "Video",
      "pricing.feat.detect.audio": "Audio",
      "pricing.feat.report.score": "Deepfake detection score",
      "pricing.feat.report.aiBasic": "Basic AI explanation",
      "pricing.feat.report.aiFull": "Full AI explanation",
      "pricing.feat.report.bilingual": "Bilingual report (ID/EN)",
      "pricing.feat.report.languages": "Report languages: {{value}}",
      "pricing.feat.report.technical": "Detailed technical report",
      "pricing.feat.report.pdf": "Download PDF report",
      "pricing.feat.storage.historyFree": "Analysis history stored",
      "pricing.feat.storage.history": "Analysis result history saved",
      "pricing.feat.storage.upload": "Can upload files for analysis",
      "pricing.feat.storage.files":
        "Original uploads are processed temporarily (not permanently stored)",
      "pricing.feat.storage.grace": "7-day grace period for paid plans",
      "pricing.feat.storage.graceDays":
        "Plan remains active for {{days}} days after cancellation",
      "pricing.feat.storage.credits": "Top up credits when quota is exhausted",
      "pricing.feat.support.center": "Help center",
      "pricing.feat.support.api": "API access",
      "pricing.feat.support.emailHours": "Email support ({{hours}} hrs)",
      "pricing.feat.free.q1": "3 analyses / month",
      "pricing.feat.free.q2": "Max. 1 analysis / day",
      "pricing.feat.free.q3": "Upload limit: 50 MB",
      "pricing.feat.starter.q1": "25 analyses / month",
      "pricing.feat.starter.q2": "Max. 5 analyses / day",
      "pricing.feat.starter.q3": "Upload limit: 200 MB",
      "pricing.feat.starter.q4": "Cooldown 30 seconds",
      "pricing.feat.starter.email": "Email support (48 hrs)",
      "pricing.feat.pro.q1": "80 analyses / month",
      "pricing.feat.pro.q2": "Max. 15 analyses / day",
      "pricing.feat.pro.q3": "Upload limit: 500 MB",
      "pricing.feat.pro.q4": "Cooldown 15 seconds",
      "pricing.feat.pro.email": "Email support (24 hrs)",
      "pricing.feat.business.q1": "250 analyses / month",
      "pricing.feat.business.q2": "Max. 40 analyses / day",
      "pricing.feat.business.q3": "Upload limit: 1 GB",
      "pricing.feat.business.q4": "Cooldown 5 seconds",
      "pricing.feat.business.email": "Priority email support (12 hrs)",
      "pricing.trust.encrypted": "Encrypted & secure",
      "pricing.trust.server": "Southeast Asia server",
      "pricing.trust.pdp": "Indonesia PDP Act compliant",
      "pricing.trust.payment": "Payments via Midtrans",
      "pricing.trial.title": "Try free for 7 days — no credit card",
      "pricing.trial.desc": "Full Starter access. Once per account.",
      "pricing.trial.cta": "Start Free Trial",
      "pricing.credit.title": "Credit Packages",
      "pricing.credit.subtitle":
        "Continue analyzing when monthly quota runs out: image 1 credit, audio 2 credits, video 3 credits. Purchased credits never expire.",
      "pricing.credit.image": "Image / Photo",
      "pricing.credit.video": "Video",
      "pricing.credit.audio": "Audio",
      "pricing.credit.buy": "Buy Credits",
      "pricing.credit.perCredit": "/ credit",
      "pricing.credit.perAnalysis": "1 credit / analysis",
      "pricing.credit.bestseller": "Best Value",
      "pricing.credit.unit": "credits",
      "pricing.credit.1credit": "1 credit",
      "pricing.credit.3credits": "3 credits",
      "pricing.credit.2credits": "2 credits",
      "pricing.retention.title": "Data Retention Policy",
      "pricing.retention.col.data": "Data",
      "pricing.retention.col.policy": "Policy",
      "pricing.retention.r1.data": "Analysis results (scores & text reports)",
      "pricing.retention.r1.policy":
        "Stored until you archive them from your account",
      "pricing.retention.r2.data": "Original uploaded media",
      "pricing.retention.r2.policy":
        "Processed temporarily for analysis and not stored permanently",
      "pricing.retention.r3.data": "Analysis thumbnail / preview",
      "pricing.retention.r3.policy": "Stored as part of your analysis history",
      "pricing.retention.r4.data": "Paid-plan grace period",
      "pricing.retention.r4.policy":
        "7 days before account falls back to Free plan",
      "pricing.retention.r5.data": "Additional credits",
      "pricing.retention.r5.policy": "Never expire",
      "pricing.faq.title": "Frequently Asked Questions",
      "pricing.faq.q1": "What are credits and how do they work?",
      "pricing.faq.a1":
        "Credits are additional balance used when your monthly plan quota runs out. After quota is exhausted, each analysis uses 1 credit. Purchased credit packages never expire.",
      "pricing.faq.q2": "What happens when my monthly credits run out?",
      "pricing.faq.a2":
        "You can purchase additional credit packages anytime without upgrading your plan. Or, upgrade to a higher plan for a larger monthly quota.",
      "pricing.faq.q3": "Can I cancel my subscription at any time?",
      "pricing.faq.a3":
        "Yes. Your subscription stays active through the current billing period. After it ends, paid plans have a 7-day grace period before the account falls back to Free.",
      "pricing.faq.q4": "What payment methods are accepted?",
      "pricing.faq.a4":
        "We accept QRIS (GoPay, OVO, DANA, LinkAja, ShopeePay), bank transfer (BCA, BNI, BRI, Mandiri), credit/debit cards, and convenience store payments (Indomaret, Alfamart). All transactions are processed securely via Midtrans.",
      "pricing.faq.q5": "Is my data secure?",
      "pricing.faq.a5":
        "All files are encrypted in transit and at rest. Servers are located in Southeast Asia for low latency to Indonesia. We comply with Indonesia's Personal Data Protection Law (UU PDP).",
      "pricing.cta.title": "Ready to detect deepfakes?",
      "pricing.cta.desc":
        "Start with a 7-day free trial. No credit card, no risk.",
      "pricing.cta.btn": "Try Veriksa Free",
      "pricing.cta.freeNow": "Start Now - Free",

      // ── Maintenance ─────────────────────────────────────────────────────
      "maintenance.badge": "Maintenance Mode",
      "maintenance.title": "System Under Maintenance",
      "maintenance.desc":
        "We are performing system maintenance to improve our service. Please check back in a moment.",
      "maintenance.validating": "Validating bypass token...",
      "maintenance.bypassActive": "Bypass Active — Admin Login",
      "maintenance.otpSent": "OTP code has been sent to your email.",
      "maintenance.adminOnly": "Access is not allowed.",
      "maintenance.tokenInvalid": "Invalid token",
      "maintenance.loginFailed": "Login failed",
      "maintenance.otpFailed": "OTP verification failed",
      "maintenance.emailPlaceholder": "Admin email",
      "maintenance.passwordPlaceholder": "Password",
      "maintenance.otpPlaceholder": "Enter OTP code",
      "maintenance.signIn": "Sign In",
      "maintenance.verifyOtp": "Verify OTP",

      // ── History ────────────────────────────────────────────────────────────
      "history.title": "Analysis History",
      "history.archive": "Forensic Archive",
      "history.stored": "{{count}} reports stored",
      "history.subtitle": "All your analysis results, stored here.",
      "history.empty": "No analyses yet.",
      "history.empty.desc": "Start your first media analysis now.",
      "history.empty.btn": "Analyze Now",
      "history.loadError": "Failed to load history",
      "history.deleteSuccess": "Deleted: {{name}}",
      "history.deleteError": "Failed to delete analysis",
      "history.delete.confirm": "Delete this analysis?",
      "history.delete.success": "Analysis deleted",
      "history.date": "Date",
      "history.verdict": "Verdict",
      "history.confidence": "Confidence",
      "history.model": "Model",
      "history.view": "View",
      "history.filter.all": "All",
      "history.filter.real": "Real",
      "history.filter.fake": "Fake",
      "history.filter.uncertain": "Uncertain",
      "history.search.placeholder": "Search title or description...",
      "history.search.btn": "Search",
      "history.clearFilters": "Clear Filters",
      "history.verdictFilter.all": "All Verdicts",
      "history.verdictFilter.fake": "High Risk",
      "history.verdictFilter.real": "Low Risk",
      "history.verdictFilter.suspicious": "Uncertain",
      "history.verdictFilter.uncertain": "Uncertain",
      "history.mediaFilter.all": "All Media",
      "history.mediaFilter.video": "Video",
      "history.mediaFilter.image": "Image",
      "history.mediaFilter.audio": "Audio",
      "history.dateRange": "Date Range",
      "history.dateFrom": "From",
      "history.dateTo": "To",
      "history.applyFilter": "Apply",
      "history.reset": "Reset",
      "history.prev": "Previous",
      "history.next": "Next",
      "history.page": "{{page}} / {{pages}}",
      "history.resetCount": "Reset ({{count}})",

      // ── Payment History ────────────────────────────────────────────────────
      "payment.title": "Payment History",
      "payment.subtitle": "All your transactions and plan upgrade history.",
      "payment.empty": "No payment history yet.",
      "payment.empty.cta": "View Plans",
      "payment.summary.total": "Total Transactions",
      "payment.summary.success": "Successful",
      "payment.summary.paid": "Total Paid",
      "payment.summary.active": "Active Plan",
      "payment.status.paid": "Successful",
      "payment.status.pending": "Pending",
      "payment.status.failed": "Failed",
      "payment.complete": "Complete payment",
      "payment.plan": "Plan",

      // ── Profile ────────────────────────────────────────────────────────────
      "profile.title": "Edit Profile",
      "profile.subtitle": "Manage your profile and account preferences.",
      "profile.name": "Full Name",
      "profile.email": "Email",
      "profile.email.hint": "Email cannot be changed",
      "profile.picture": "Profile Picture (URL)",
      "profile.picture.hint": "Enter a public image URL",
      "profile.language": "Language",
      "profile.language.id": "Indonesia",
      "profile.language.en": "English",
      "profile.save": "Save Changes",
      "profile.saved": "Profile saved successfully!",
      "profile.password.title": "Change Password",
      "profile.password.old": "Old Password",
      "profile.password.new": "New Password",
      "profile.password.hint": "Minimum 8 characters",
      "profile.password.save": "Change Password",
      "profile.password.success": "Password changed successfully!",
      "profile.google.hint": "Google accounts cannot change password here.",
      "profile.plan": "Plan",
      "profile.member.since": "Member since",
      "profile.recharge.title": "Auto-Recharge Credits",

      // Notifications
      "profile.notifications.title": "Notifications",
      "profile.notifications.label": "Push Notifications",
      "profile.notifications.desc":
        "Get notified when analysis completes, quota runs low, or payment succeeds.",
      "profile.notifications.enable": "Enable",
      "profile.notifications.active": "Active",
      "profile.notifications.enabled": "Notifications enabled",
      "profile.notifications.denied": "Blocked",
      "profile.notifications.deniedHint": "Change in browser settings",
      "profile.notifications.blocked":
        "Notifications blocked by browser. Change in your browser settings.",
      "profile.notifications.disable": "Disable",
      "profile.notifications.disabled": "Notifications disabled",
      "profile.training.title": "AI Training Data Contribution",
      "profile.training.label": "Allow analysis data to improve model quality",
      "profile.training.desc":
        "Optional. Only data you allow can be used for model-improvement research. You can turn this off anytime.",
      "profile.training.on": "AI data contribution enabled",
      "profile.training.off": "AI data contribution disabled",
      "profile.training.save": "Save Preference",
      "profile.training.saving": "Saving...",
      "profile.training.updatedAt": "Updated: {{date}}",
      "profile.training.error": "Failed to save data contribution preference",
      "profile.recharge.label": "Automatic credit top-up",
      "profile.recharge.desc":
        "When your monthly quota runs out, the system will automatically top up your credits using your saved payment method.",
      "profile.recharge.typeLabel": "Recharge Type",
      "profile.recharge.package": "Select Package",
      "profile.recharge.custom": "Custom Amount",
      "profile.recharge.selectPack": "Select Package",
      "profile.recharge.credits": "credits",
      "profile.recharge.nominalLabel": "Amount (IDR)",
      "profile.recharge.nominalMin": "Min. Rp 10,000 - Max. Rp 1,000,000",
      "profile.recharge.nominalError": "Minimum amount is Rp 10,000",
      "profile.recharge.save": "Save Settings",
      "profile.recharge.saving": "Saving...",
      "profile.recharge.on": "Auto-recharge enabled",
      "profile.recharge.off": "Auto-recharge disabled",
      "profile.recharge.error": "Failed to update settings",
      "profile.recharge.statusPackage":
        "Auto-recharge: {{credits}} credits (Rp {{price}}) when quota runs out.",
      "profile.recharge.statusCustom":
        "Auto-recharge: Rp {{amount}} when quota runs out.",

      // ── Forgot Password ────────────────────────────────────────────────────
      "forgot.title": "Forgot Password",
      "forgot.desc": "Enter your email address to receive a verification code.",
      "forgot.step.email": "Email",
      "forgot.step.verify": "Verify",
      "forgot.step.newPw": "New Password",
      "forgot.email.label": "Email Address",
      "forgot.email.submit": "Send OTP Code",
      "forgot.email.sending": "Sending...",
      "forgot.email.success": "OTP code sent to your email",
      "forgot.email.error": "Failed to send OTP",
      "forgot.otp.title": "Verify OTP",
      "forgot.otp.desc": "Enter the 6-digit code sent to your email.",
      "forgot.otp.label": "OTP Code (6 digits)",
      "forgot.otp.submit": "Verify",
      "forgot.otp.verifying": "Verifying...",
      "forgot.otp.error": "Invalid OTP",
      "forgot.otp.resend": "Resend OTP",
      "forgot.otp.resending": "Sending...",
      "forgot.otp.resendError": "Failed to resend",
      "forgot.reset.title": "Create New Password",
      "forgot.reset.desc": "Create a new password with at least 8 characters.",
      "forgot.reset.label": "New Password",
      "forgot.reset.confirm": "Confirm Password",
      "forgot.reset.submit": "Save New Password",
      "forgot.reset.saving": "Saving...",
      "forgot.reset.success":
        "Your new password has been saved! Please sign in.",
      "forgot.reset.error": "Failed to reset password",
      "forgot.back": "Back to login",

      // ── Register Hero ──────────────────────────────────────────────────────
      "register.hero.badge": "Media Risk Analysis",
      "register.hero.title":
        "Protect Yourself from\nDigital Media Manipulation",
      "register.hero.desc":
        "Sign up free and start verifying media with cutting-edge AI forensics. No credit card required.",
      "register.hero.f1": "Next-generation AI-powered deepfake detection",
      "register.hero.f2": "Support for multiple media formats & social URLs",
      "register.hero.f3": "Complete forensic reports with confidence scores",
      "register.hero.footer": "© 2026 Veriksa · Powered by Gemini 2.5 Pro",
      "register.otp.title": "Verify Email",
      "register.otp.desc": "Code sent to",
      "register.otp.label": "OTP Code (6 digits)",
      "register.otp.submit": "Verify & Register",
      "register.otp.verifying": "Verifying...",
      "register.otp.resend": "Resend OTP",
      "register.otp.resending": "Sending...",
      "register.otp.back": "Back to sign-up form",
      "register.otp.sent": "Verification code sent to your email",
      "register.otp.error": "Registration failed",
      "register.otp.invalid": "Invalid OTP",
      "register.otp.resent": "New OTP sent!",
      "register.otp.resendError": "Failed to resend OTP",

      // ── Analyze Extra ─────────────────────────────────────────────────────
      "analyze.tip.best":
        "Short clips (< 3 min) with clear faces give best results.",
      "analyze.tip.accuracy":
        "Higher resolution media improves detection accuracy.",
      "analyze.tip.privacy":
        "Media is processed temporarily and deleted after analysis.",
      "analyze.tip.bestLabel": "Best results",
      "analyze.tip.accuracyLabel": "Accuracy",
      "analyze.tip.privacyLabel": "Privacy",
      "analyze.autoRecharge.toast":
        "Quota exhausted — auto-recharge payment prepared...",
      "analyze.autoRecharge.title": "Auto-Recharge Prepared",
      "analyze.autoRecharge.desc":
        "{{credits}} credits (Rp {{amount}}) awaiting payment. Credits activate immediately after payment.",
      "analyze.autoRecharge.pay": "Pay Now",
      "analyze.autoRecharge.dismiss": "Dismiss",

      // ── Admin Email Blast ────────────────────────────────────────────────
      "admin.blast.title": "Email Blast",
      "admin.blast.subtitle": "Send bulk emails to specific user segments.",
      "admin.blast.compose": "Compose Email",
      "admin.blast.subject": "Subject",
      "admin.blast.subjectPlaceholder": "Important announcement from Veriksa",
      "admin.blast.message": "Message",
      "admin.blast.messagePlaceholder": "Write your message here...",
      "admin.blast.target": "Target Recipients",
      "admin.blast.targetAll": "All Users",
      "admin.blast.targetFree": "Free Plan",
      "admin.blast.targetPaid": "Paid Users (Starter/Pro/Business)",
      "admin.blast.targetAdmin": "Admin Only",
      "admin.blast.send": "Send",
      "admin.blast.sending": "Sending...",
      "admin.blast.sendSuccess": "Email queued for {{count}} users!",
      "admin.blast.sendError": "Failed to send blast",
      "admin.blast.sandboxNote":
        "Sandbox Mailtrap: max 1 email/10 sec. Production: use Mailtrap Email Delivery.",
      "admin.blast.history": "Blast History",
      "admin.blast.noHistory": "No blast history yet",
      "admin.blast.clickDetail": "Click for details",
      "admin.blast.sent": "sent",
      "admin.blast.failed": "failed",
      "admin.blast.detailError": "Failed to load blast details",
      "admin.blast.subjectRequired": "Subject and message are required",
      "admin.blast.detailMessage": "Message",
      "admin.blast.detailAll": "All",
      "admin.blast.detailNoRecipient": "No recipients",
      "admin.digest.title": "Weekly Digest",
      "admin.digest.desc":
        "Weekly summary sent automatically every Monday 09:00 WIB. Can also trigger manually.",
      "admin.digest.send": "Send Now",
      "admin.digest.sending": "Sending...",
      "admin.digest.success": "Weekly digest is being sent in background!",
      "admin.digest.error": "Failed to send digest",
      "admin.digest.date": "Date",
      "admin.digest.sent": "Sent",
      "admin.digest.failed": "Failed",
      "admin.digest.total": "Total Users",

      // ── Admin Finance ─────────────────────────────────────────────────────
      "admin.finance.title": "Finance",
      "admin.finance.period": "Period",
      "admin.finance.revenue": "Revenue",
      "admin.finance.cogs": "COGS (Gemini AI)",
      "admin.finance.grossProfit": "Gross Profit",
      "admin.finance.margin": "Margin",
      "admin.finance.today": "Today",
      "admin.finance.analyses": "analyses",
      "admin.finance.transactions": "transactions",
      "admin.finance.profitStatus": "PROFIT",
      "admin.finance.lossStatus": "LOSS",
      "admin.finance.trend": "Revenue vs Cost Trend",
      "admin.finance.byType": "Revenue by Type",
      "admin.finance.byPlan": "Revenue by Plan",
      "admin.finance.noData": "No data for this period",

      // ── Admin System ──────────────────────────────────────────────────────
      "admin.system.title": "System",
      "admin.system.subtitle": "Monitor API health and platform configuration.",
      "admin.system.health": "API Health",
      "admin.system.config": "Platform Config",
      "admin.system.maintenance": "Maintenance Mode",
      "admin.system.maintenanceDesc":
        "Disable all user access to platform. Admin can still login.",
      "admin.system.registration": "User Registration",
      "admin.system.registrationDesc":
        "Allow new users to register on Veriksa.",
      "admin.system.refresh": "Refresh",
      "admin.system.healthFail": "Failed to load health",
      "admin.system.configUpdated": "Config updated",
      "admin.system.configFail": "Failed to update",
      "admin.system.dbStats": "Database Stats",
      "admin.system.maintenanceMsg": "Maintenance Message",
      "admin.system.maintenanceMsgPlaceholder":
        "System is under maintenance. Please try again later.",
      "admin.system.maintenanceMsgDesc":
        "This message is shown to users when maintenance mode is active.",
      "admin.system.maintenanceMsgSaved": "Maintenance message saved",
      "admin.system.annualBilling": "Annual Billing Switch",
      "admin.system.annualBillingDesc":
        "Enable Monthly/Annual switcher on the pricing page.",
      "admin.system.annualDiscount": "Annual Discount Configuration",
      "admin.system.annualDiscountDesc":
        "When annual billing is ON, set discount as percentage or nominal IDR.",
      "admin.system.discountType": "Discount Type",
      "admin.system.discountPercent": "Percentage (%)",
      "admin.system.discountNominal": "Nominal (IDR)",
      "admin.system.discountValue": "Discount Value",
      "admin.system.discountPercentMax": "Maximum {{max}}%",
      "admin.system.discountNominalMax": "Maximum Rp {{max}}",
      "admin.system.discountPreviewLabel": "Discount Preview",
      "admin.system.discountPreviewStarter":
        "Estimated Starter saving: Rp {{value}} / year",
      "admin.system.planDist": "Plan Distribution",
      "admin.system.activeUsers": "Active Users",
      "admin.system.last7days": "Last 7 days",
      "admin.packages.title": "Package Management",
      "admin.packages.subtitle":
        "Manage per-plan media access in a SaaS-style package matrix.",
      "admin.packages.mediaAccessTitle": "Media Type Access by Plan",
      "admin.packages.mediaAccessDesc":
        "Control whether each plan can analyze image, video, or audio.",
      "admin.packages.planSettingsTitle": "Plan Settings",
      "admin.packages.planSettingsDesc":
        "Manage monthly price, quota, daily limit, upload max size, and cooldown for main plans.",
      "admin.packages.mainPlanPolicy":
        "Main plans support up to 10 plans. Private plans are hidden from public pricing.",
      "admin.packages.mainAdd": "Add Main Plan",
      "admin.packages.mainCount": "{{count}} / {{max}} main plans",
      "admin.packages.main.maxTen": "Maximum {{max}} main plans.",
      "admin.packages.matrixTitle": "Plan Configuration Matrix",
      "admin.packages.matrixDesc":
        "Manage all plan settings in a single table for cleaner and more comfortable data entry.",
      "admin.packages.annualTitle": "Annual Billing Configuration",
      "admin.packages.annualDesc":
        "Move monthly/annual switch and annual discount settings into Packages page.",
      "admin.packages.field.name": "Plan Name",
      "admin.packages.field.status": "Plan Status",
      "admin.packages.field.price": "Monthly Price (IDR)",
      "admin.packages.field.monthlyLimit": "Monthly Quota (analyses)",
      "admin.packages.field.dailyLimit": "Daily Limit (analyses)",
      "admin.packages.field.fileLimit": "Upload Max Size (MB)",
      "admin.packages.field.cooldown": "Cooldown (seconds)",
      "admin.packages.field.maxVideoDuration":
        "Max video duration (seconds, 0 = unlimited)",
      "admin.packages.field.maxAudioDuration":
        "Max audio duration (seconds, 0 = unlimited)",
      "admin.packages.visibilityPublic": "Show on Pricing",
      "admin.packages.featureTitle": "Plan Features (CRUD)",
      "admin.packages.featureDesc":
        "Manage report, storage, credit topup, and support capabilities for each plan.",
      "admin.packages.feature.storageUpload": "Can upload files for analysis",
      "admin.packages.feature.graceDays":
        "Plan remains active after cancellation (days)",
      "admin.packages.feature.supportSlaHours": "Email support SLA (hours)",
      "admin.packages.ai.none": "None",
      "admin.packages.ai.basic": "Basic",
      "admin.packages.ai.full": "Full",
      "admin.packages.language.id": "ID",
      "admin.packages.language.en": "EN",
      "admin.packages.state.enabled": "Enabled",
      "admin.packages.state.disabled": "Disabled",
      "admin.packages.state.public": "Public",
      "admin.packages.state.private": "Private",
      "admin.packages.state.popular": "Popular",
      "admin.packages.state.mostUsed": "Most used",
      "admin.packages.state.notMostUsed": "Not most used",
      "admin.packages.creditTitle": "Add-on Credit Packages CRUD",
      "admin.packages.creditDesc":
        "Add, edit, or delete top-up credit packages (maximum 10 packages).",
      "admin.packages.creditAdd": "Add Credit Package",
      "admin.packages.creditCount": "{{count}} / 10 packages",
      "admin.packages.creditLabel": "Label",
      "admin.packages.creditCredits": "Credits",
      "admin.packages.creditPrice": "Price (IDR)",
      "admin.packages.creditAction": "Action",
      "admin.packages.creditEmpty": "No credit package yet.",
      "admin.packages.credit.maxTen": "Maximum 10 credit packages.",
      "admin.packages.loadFail": "Failed to load package configuration.",
      "admin.packages.saved": "Package configuration saved.",
      "admin.packages.saveFail": "Failed to save package configuration.",

      // ── Admin Audit Log ────────────────────────────────────────────────────
      "admin.audit.title": "Audit Log",
      "admin.audit.subtitle":
        "Record of all admin activities with TTL auto-delete.",
      "admin.audit.search": "Search",
      "admin.audit.searchPlaceholder": "Search admin email or target...",
      "admin.audit.action": "Action",
      "admin.audit.allActions": "All Actions",
      "admin.audit.dateFrom": "From",
      "admin.audit.dateTo": "To",
      "admin.audit.refresh": "Refresh",
      "admin.audit.showing": "Showing {{count}} of {{total}} logs",
      "admin.audit.ttlNote": "Logs auto-deleted after 1 year",
      "admin.audit.noLogs": "No activity recorded yet.",
      "admin.audit.colTime": "Time",
      "admin.audit.colAdmin": "Admin",
      "admin.audit.colAction": "Action",
      "admin.audit.colTarget": "Target",
      "admin.audit.colDetails": "Details",
      "admin.audit.colIP": "IP",
      "admin.audit.page": "Page {{page}} of {{pages}}",
      "admin.audit.fetchError": "Failed to load audit log",

      // ── Admin Users Page ───────────────────────────────────────────────────
      "admin.usersPage.title": "Users",
      "admin.usersPage.count": "{{count}} users",
      "admin.usersPage.countFiltered": "{{filtered}} of {{total}} users",
      "admin.usersPage.createUser": "Create User",
      "admin.usersPage.searchPlaceholder": "Search name or email...",
      "admin.usersPage.allPlans": "All Plans",
      "admin.usersPage.allRoles": "All Roles",
      "admin.usersPage.thUser": "User",
      "admin.usersPage.thRole": "Role",
      "admin.usersPage.thPlan": "Plan",
      "admin.usersPage.thUsage": "Usage",
      "admin.usersPage.thJoined": "Joined",
      "admin.usersPage.thActions": "Actions",
      "admin.usersPage.noMatch": "No matching users",
      "admin.usersPage.noUsers": "No users found",
      "admin.usersPage.deleteConfirm":
        "Delete user {{email}}? All user data will be permanently removed.",
      "admin.usersPage.deleteSuccess": "User deleted",
      "admin.usersPage.deleteFail": "Failed to delete user",
      "admin.usersPage.loadFail": "Failed to load users",
      "admin.usersPage.updated": "Updated",
      "admin.usersPage.updateFail": "Failed to update",
      "admin.usersPage.modalCreate": "Create New User",
      "admin.usersPage.modalEdit": "Edit User",
      "admin.usersPage.modalView": "User Detail",
      "admin.usersPage.lblName": "Name",
      "admin.usersPage.lblEmail": "Email",
      "admin.usersPage.lblPassword": "Password",
      "admin.usersPage.lblPlan": "Plan",
      "admin.usersPage.lblRole": "Role",
      "admin.usersPage.lblUsageCount": "Usage Count",
      "admin.usersPage.phName": "Full name",
      "admin.usersPage.phEmail": "email@example.com",
      "admin.usersPage.phPassword": "Min. 8 characters",
      "admin.usersPage.cancel": "Cancel",
      "admin.usersPage.save": "Save",
      "admin.usersPage.create": "Create User",
      "admin.usersPage.saveFail": "Failed to save",
      "admin.usersPage.createSuccess": "User created successfully!",
      "admin.usersPage.updateSuccess": "User updated!",
      "admin.usersPage.loadDetailFail": "Failed to load user data",
      "admin.usersPage.requiredFields":
        "Name, email, and password are required",
      "admin.usersPage.analyses": "Analyses",
      "admin.usersPage.usage": "Usage",
      "admin.usersPage.credits": "Credits",
      "admin.usersPage.authType": "Auth Type",
      "admin.usersPage.joined": "Joined",
      "admin.usersPage.usageReset": "Usage Reset",
      "admin.usersPage.recentAnalyses": "Recent Analyses",
      "admin.usersPage.recentTx": "Recent Transactions",

      // ── Admin Analyses Page ────────────────────────────────────────────────
      "admin.analysesPage.title": "Analyses",
      "admin.analysesPage.totalDesc":
        "{{total}} total analysis results on platform.",
      "admin.analysesPage.all": "All",
      "admin.analysesPage.searchPlaceholder": "Search media or user...",
      "admin.analysesPage.search": "Search",
      "admin.analysesPage.reset": "Reset",
      "admin.analysesPage.thVideo": "Media",
      "admin.analysesPage.thUser": "User",
      "admin.analysesPage.thVerdict": "Verdict",
      "admin.analysesPage.thConf": "Conf.",
      "admin.analysesPage.thType": "Type",
      "admin.analysesPage.thViews": "Views",
      "admin.analysesPage.thDate": "Date",
      "admin.analysesPage.loading": "Loading...",
      "admin.analysesPage.noDataFilter": "No data matching filters",
      "admin.analysesPage.noData": "No data",

      // ── Admin Transactions Page ────────────────────────────────────────────
      "admin.txPage.title": "Transactions",
      "admin.txPage.totalDesc": "{{total}} total transactions.",
      "admin.txPage.totalRevenue": "Total Revenue",
      "admin.txPage.searchPlaceholder": "Search user name or email...",
      "admin.txPage.search": "Search",
      "admin.txPage.allTypes": "All Types",
      "admin.txPage.allStatus": "All Status",
      "admin.txPage.allPlans": "All Plans",
      "admin.txPage.reset": "Reset",
      "admin.txPage.thUser": "User",
      "admin.txPage.thType": "Type",
      "admin.txPage.thPlanCredits": "Plan / Credits",
      "admin.txPage.thAmount": "Amount",
      "admin.txPage.thStatus": "Status",
      "admin.txPage.thDate": "Date",
      "admin.txPage.loading": "Loading...",
      "admin.txPage.noDataFilter": "No transactions matching filters",
      "admin.txPage.noData": "No transactions yet",
      "admin.txPage.credits": "credits",
      "admin.reports.tag": "Content Moderation",
      "admin.reports.title": "Flag Reports",
      "admin.reports.subtitlePrefix": "User reports —",
      "admin.reports.subtitleSuffix": "total",
      "admin.reports.refresh": "Refresh",
      "admin.reports.filter.label": "Filter:",
      "admin.reports.filter.allStatus": "All Status",
      "admin.reports.filter.allReasons": "All Reasons",
      "admin.reports.filter.reset": "Reset",
      "admin.reports.filter.clear": "Clear Filters",
      "admin.reports.filter.active": "active filters",
      "admin.reports.status.pending": "Pending",
      "admin.reports.status.reviewed": "Reviewed",
      "admin.reports.status.dismissed": "Dismissed",
      "admin.reports.bulk.selected": "{{count}} selected",
      "admin.reports.bulk.markReviewed": "Mark Reviewed",
      "admin.reports.bulk.dismiss": "Dismiss",
      "admin.reports.empty.default": "No reports found.",
      "admin.reports.empty.withStatus": 'No reports with status "{{status}}".',
      "admin.reports.table.analysis": "Analysis",
      "admin.reports.table.reason": "Reason",
      "admin.reports.table.details": "Details",
      "admin.reports.table.reportedAt": "Reported",
      "admin.reports.table.type": "Type",
      "admin.reports.table.status": "Status",
      "admin.reports.table.actions": "Actions",
      "admin.reports.action.markReviewed": "Mark as Reviewed",
      "admin.reports.action.dismiss": "Dismiss Report",
      "admin.reports.action.delete": "Delete Report",
      "admin.reports.pagination.page": "Page",
      "admin.reports.pagination.reports": "reports",
      "admin.reports.deleteConfirm.title": "Delete Report?",
      "admin.reports.deleteConfirm.single":
        "This report will be permanently deleted.",
      "admin.reports.deleteConfirm.multiple":
        "{{count}} reports will be permanently deleted.",
      "admin.reports.toast.loadError": "Failed to load content reports.",
      "admin.reports.toast.markedReviewed": "Marked as reviewed.",
      "admin.reports.toast.dismissed": "Report dismissed.",
      "admin.reports.toast.updateStatusError": "Failed to update status.",
      "admin.reports.toast.deleted": "Report deleted.",
      "admin.reports.toast.deleteError": "Failed to delete report.",
      "admin.reports.toast.bulkDeleted": "{{count}} reports deleted.",
      "admin.reports.toast.bulkUpdated": "{{count}} reports updated.",
      "admin.reports.toast.bulkError": "Failed to run bulk action.",

      // ── Notifications ─────────────────────────────────────────────────────
      "notify.loggedOut": "Signed out successfully. See you next time!",
      "notify.permission.title": "Enable Notifications",
      "notify.permission.desc":
        "Get instant alerts for completed analyses, low quota warnings, and payment confirmations.",
      "notify.permission.allow": "Enable",
      "notify.permission.later": "Later",

      // ── User Analytics ─────────────────────────────────────────────────────
      "analytics.title": "Analytics",
      "analytics.subtitle":
        "Usage statistics and trends for your media analyses.",
      "analytics.totalAnalyses": "Total Analyses",
      "analytics.avgConfidence": "Avg. Confidence",
      "analytics.thisWeek": "This Week",
      "analytics.lastWeek": "Last week",
      "analytics.quota": "Quota",
      "analytics.credits": "credits",
      "analytics.weeklyTrend": "Weekly Trend (8 Weeks)",
      "analytics.analyses": "Analyses",
      "analytics.confidence": "Confidence",
      "analytics.noData": "No data yet. Start your first analysis!",
      "analytics.verdictDist": "Verdict Distribution",
      "analytics.usageProgress": "Quota Usage",
      "analytics.monthlyUsage": "Monthly Quota",
      "analytics.creditsBalance": "Credit Balance",
      "analytics.upgradePlan": "Upgrade plan",
      "analytics.recentAnalyses": "Recent Analyses",
      "analytics.noAnalyses": "No analyses yet",
      "analytics.viewAll": "View all history",
      "analytics.confByVerdict": "Confidence by Verdict",
      "analytics.mediaType": "Media Type",
      "admin.stats.users": "Total Users",
      "admin.stats.analyses": "Total Analyses",
      "admin.stats.revenue": "Estimated Revenue",
      "admin.stats.today": "Today's Analyses",
      "admin.users.title": "User List",
      "admin.users.search": "Search users...",
      "admin.users.name": "Name",
      "admin.users.email": "Email",
      "admin.users.plan": "Plan",
      "admin.users.usage": "Usage",
      "admin.users.joined": "Joined",
      "admin.users.actions": "Actions",
      "admin.users.promote": "Make Admin",
      "admin.users.delete": "Delete",
      "admin.users.changePlan": "Change Plan",

      // ── Common ────────────────────────────────────────────────────────────
      "common.loading": "Loading...",
      "common.error": "Something went wrong",
      "common.save": "Save",
      "common.cancel": "Cancel",
      "common.confirm": "Confirm",
      "common.close": "Close",

      // ── Footer ────────────────────────────────────────────────────────────
      "footer.tagline": "Verify media in the digital content era.",
      "footer.product": "Product",
      "footer.company": "Company",
      "footer.legal": "Legal",
      "footer.about": "About Us",
      "footer.contact": "Contact",
      "footer.terms": "Terms & Conditions",
      "footer.privacy": "Privacy Policy",
      "footer.apiDocs": "API Docs",
      "footer.rights": "Truth in Every Frame",
      "footer.madeIn": "Built with AI in Indonesia",

      // ── Verification Banner ───────────────────────────────────────────────
      "verify.banner.text": "Email not yet verified. Check your inbox at",
      "verify.banner.link": "for your verification link.",
      "verify.banner.resend": "Resend",
      "verify.banner.sending": "Sending...",
      "verify.banner.sent": "Verification email resent. Check your inbox.",
      "verify.banner.tooMany":
        "Too many requests. Please try again in 15 minutes.",
      "verify.banner.failed": "Failed to send verification email.",

      // ── Resend Verification ───────────────────────────────────────────────
      "resend.back": "Back",
      "resend.sent.title": "Email Sent",
      "resend.sent.desc": "Verification link sent to:",
      "resend.sent.note":
        "Please check your email and click the verification link. The link is valid for 15 minutes.",
      "resend.sent.redirecting": "Redirecting to home...",
      "resend.title": "Resend Verification",
      "resend.subtitle":
        "Email not yet verified? We'll send a verification link to your email.",
      "resend.email.label": "Email Address",
      "resend.submit": "Send Verification Link",
      "resend.submitting": "Sending...",
      "resend.error.tooMany":
        "Too many requests. Please try again in 15 minutes.",
      "resend.error.failed": "Failed to send verification email.",
      "resend.error.generic": "Something went wrong. Please try again.",
      "resend.success": "Verification email sent. Please check your inbox.",
      "resend.haveAccount": "Remember your password?",
      "resend.signIn": "Sign in now",
      "resend.noAccount": "Don't have an account?",
      "resend.register": "Register here",
      "emailVerification.loading.title": "Verifying Email",
      "emailVerification.loading.subtitle": "Please wait a moment...",
      "emailVerification.success.title": "✓ Email Verified!",
      "emailVerification.success.desc":
        "Your account has been activated successfully. Welcome to Veriksa!",
      "emailVerification.success.redirecting": "Redirecting to login...",
      "emailVerification.error.title": "Verification Failed",
      "emailVerification.error.missingToken": "Verification token not found",
      "emailVerification.error.verifyFailed": "Failed to verify email",
      "emailVerification.error.resendTitle":
        "Having trouble with your verification link?",
      "emailVerification.error.resendDesc":
        "You can request a new verification link from the resend verification page.",
      "emailVerification.error.resendBtn": "Request New Link →",
      "emailVerification.error.backToLogin": "Back to Login",
      "emailVerification.error.backToRegister": "Register Again",
      "emailVerification.help.prefix": "Questions?",
      "emailVerification.help.link": "Contact support",
    },
  },
};

i18n.use(initReactI18next).init({
  resources,
  lng: "id",
  fallbackLng: "id",
  supportedLngs: ["id", "en"],
  nonExplicitSupportedLngs: true,
  load: "languageOnly",
  defaultNS: "translation",
  interpolation: { escapeValue: false },
});

export default i18n;
